import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { DigitalVaultDocumentView } from '../../views'
import { LocalStorageService, QuestionnaireService, CategoryService, DigitalVaultService, DigitalVaultDocumentService, DocumentLogsService, CacheStorageService, UserService, AlertService, ClientService, DocumentsType, WorkflowMessagesService } from '../../../services'
import { changeFormatNumberToShow, decryptMessageBoveda, FormatTextUtil, getNavigatorTimezone, parseEntities, setCreditsToDocuments } from '../../../utils'

class DigitalVaultDocumentAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showWarning: false,
            showCompletedRequesting: false,
            messageComplete: '',
            messageError: '',
            messageWarning: '',
            showPrincipalView: true,
            showEditView: false,
            fromDelete: false,
            id: 0,
            dataLoaded: false,
            documentData: {
                id: 0,
                name: '',
                alias: '',
                description: '',
                nameUser: '',
                infoType: '',
                typeDocument: '',
                startDate: '',
                validationDate: '',
                amount: '',
                tags: '',
                confidential: false,
                obligatory: false,
                penaltyFee: '',
                renewal: '',
                daysTo: 0,
                percent: 0,
                signedInGovo: false
            },
            showBasicInfo: true,
            showCircle: false,
            formatTransaction: '$0.0',
            formatPenaltyFee: '$0.0',
            showActions: true,
            showPDF: true,
            showPanelVaribales: true,
            showPanelBinnacle: true,
            showVersions: false,
            showPanelEntities: true,
            variables: [],
            binnacle: [],
            url: '',
            permissions: [],
            removeTags: false,
            selectedFile: null,
            selectedFileName: '',
            errorFile: false,
            selectedFileBase64: '',
            colorBorderContainer: 'gray',
            fileWasUpload64: '',
            actionOptions: [],
            versions: [],
            showVersionsBtns: true,
            showExpediente: false,
            filesExpediente: [],
            fileExpSelected: {},
            versionSelected: {},
            userCollaborators: [],
            showBtnAddDocumentToExp: false,
            monetaryUnits: [],
            fileType: 'pdf',
            asn1Decode: [],
            typesDocuments: [],
            typeDocumentId: null,
            variablesGrid: [],
            entities: [],
            entitiesStatus: '',
            showDialogExtractEntities: false,
            documentsToOCR: [],
            totalCredits: 0,
            filesDocument: [],
            titleDialog: '',
            formatVariables: [],
            showLeftDownload: false,
            showShareLeft: false,
            showDeleteLeft: false,
            showEditLeft: false,
            showBtnExtractEntities: false,
            preferenceIA: process.env.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ON_DEMAND,
            usersChat: {},
            conversation: [],
            membersChat: [],
            externalDocuments: [],
            userIsApplicant: false,
            userIsValidator: false,
            userIsShared: false,
            externalDocumentsLoaded: false,
            externalDocumentsInfoType: 'Documento',
            externalDocumentsLimit: 10,
            externalDocumentsInstructions: '',
            externalDocumentsLimitDate: null,
            externalDocumentsStatusCurrent: null,
            usersDocumentsRaw: [],
            externalDocumentsCurrentUserId: null,
            documentOwnerId: null,
            isExternalUserView: false,
            infoTitle: '',
            infoMessage: '',
            labelInfoBtn: '',
            showInfoRequesting: false,
            selectedUsers: [],
            userDocumentLists: {},
            userInstructions: {},
            requestDeadline: new Date(new Date().setDate(new Date().getDate() + 7)),
            enableSecondApproval: false,
            secondApprovalUser: null,
            documentGroups: [],
            documentTemplates: [],
            showNoAccessModal: false,
            noAccessMessage: ''
        }
    }
    ENV = process.env
    token = {}
    user = {}
    id = 0
    url = this.ENV.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()
    categoryService = new CategoryService(process.env.REACT_APP_MIFIRMA_API)
    digitalVaultService = new DigitalVaultService(this.url)
    documentLogsService = new DocumentLogsService(process.env.REACT_APP_MIFIRMA_API)
    digitalVaultDocumentService = new DigitalVaultDocumentService(this.url)
    documentTypesService = new DocumentsType(this.url)
    alertService = new AlertService(this.url)
    questionnaireService = new QuestionnaireService(this.url)
    userService = new UserService(this.url)
    cache = new CacheStorageService()
    formatTextUtil = new FormatTextUtil()
    clientPreferencesService = new ClientService(this.url)
    workflowMessagesService = new WorkflowMessagesService(this.url)

    timezone = getNavigatorTimezone()
    idAuthorMessage = null  // ID del usuario actual en el chat

    loadingDocumentData = false
    loadingBinnacle = false
    loadingUsersCollabs = false
    loadingMonetaryUnits = false
    loadingFormatVariables = false
    loadingExternalDocuments = false
    uploadedDocumentsPendingNotification = new Set()

    /**
     * @typedef {(data: import('../../../types/alerts.types').AlertData) => Promise<boolean>} CreateAlert
     * @param {import('../../../types/alerts.types').AlertData} data
     * @returns {Promise<boolean>}
     */

    async componentDidMount() {
        if (this.state.dataLoaded || this.state.isLoading) {
            return
        }
        this.toggleLoadingView(true)
        this.token = this.localStorageService.getLocalStorageItem('token').idToken
        this.user = this.localStorageService.getLocalStorageItem('user')
        this.id = this.props.documentId

        const searchParams = new URLSearchParams(window.location.search)
        const hash = window.location.hash || ''
        const queryString = hash.includes('?') ? hash.split('?')[1] : ''
        const hashParams = new URLSearchParams(queryString)
        const workflowExecutionExternalId = hashParams.get('workflowExecutionExternalId') || searchParams.get('workflowExecutionExternalId')

        this.setState({ isExternalUserView: !!workflowExecutionExternalId })

        const fromDelete = (typeof this.props.fromDelete === 'boolean')
            ? this.props.fromDelete
            : (hashParams.get('fromDelete') === 'true' || searchParams.get('fromDelete') === 'true')

        this.setState({
            fromDelete: fromDelete,
            id: this.props.documentId,
            dataLoaded: true
        })

        try {
            if (workflowExecutionExternalId) {
                await Promise.all([
                    this.getDocumentData(),
                    this.getBinnacle(),
                    this.getDocumentMessages(),
                    this.getExternalDocuments(),
                    this.fetchDocumentGroupsAndTemplates(),
                    this.getFormatVariables()
                ])
            } else {
                await Promise.all([
                    this.getDocumentData(),
                    this.getBinnacle(),
                    this.getUsersCollabs(),
                    this.getMonetaryUnits(),
                    this.getFormatVariables(),
                    this.getDocumentMessages(),
                    this.getExternalDocuments(),
                    this.fetchDocumentGroupsAndTemplates()
                ])
            }
        } catch (error) {
            console.error('Error loading initial data:', error)
        }
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.documentId !== this.props.documentId) {
            this.setState({ dataLoaded: false }, () => {
                this.componentDidMount()
            })
        }
    }

    componentWillUnmount() {
        this.sendPendingUploadNotifications()
    }

    /**
     * @function sendPendingUploadNotifications
     * @description Envía notificaciones por correo para documentos subidos (UPLOADED) cuando el usuario sale
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    sendPendingUploadNotifications = async () => {
        if (this.uploadedDocumentsPendingNotification.size === 0) return

        const recipientIds = Array.from(this.uploadedDocumentsPendingNotification)

        for (const recipientId of recipientIds) {
            try {
                await this.digitalVaultDocumentService.sendExternalDocumentNotification(
                    this.id,
                    recipientId,
                    process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_UPLOADED,
                    this.token
                )
            } catch (error) {
                console.error(`Error enviando notificación UPLOADED para recipientId ${recipientId}:`, error)
            }
        }

        this.uploadedDocumentsPendingNotification.clear()
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleWarning = (message, time, title) => {
        this.setState({
            showWarning: true,
            messageWarning: message,
            titleDialog: title
        }, () => {
            setTimeout(() => {
                this.setState({
                    showWarning: false,
                })
            }, time || 0)
        })
    }

    toggleErrorRequesting = (message, time, sendInbox, path, title) => {
        let sendTo = (path && path !== '') ? path : '/'
        this.setState({
            showErrorRequesting: true,
            messageError: message,
            titleDialog: title
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path, title, message) => {
        let sendTo = (path && path !== '') ? path : '/'
        this.setState({
            showCompletedRequesting: true,
            messageComplete: message,
            titleDialog: title
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time)
        })
    }

    getDocumentData = async () => {
        if (this.loadingDocumentData) {
            console.warn('getDocumentData already in progress, skipping duplicate call')
            return
        }
        this.loadingDocumentData = true
        let messageError = 'Ocurrió un error al consultar la infomación del documento'
        try {
            let documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
            const statusCode = Number(documentInfo?.statusCode)

            if (!documentInfo || statusCode === Number(process.env.REACT_APP_DIGITAL_TRACKING_DENIED_ACCESS) || statusCode === Number(process.env.REACT_APP_DIGITAL_VAULT_ROLE_QUERY)) {
                this.toggleLoadingView(false)
                this.setState({
                    showNoAccessModal: true,
                    noAccessMessage: this.props.t('digitalVaultView.noAccessMessage'),
                    isLoading: false,
                    dataLoaded: true
                }, () => {
                })
                this.loadingDocumentData = false
                return true
            }

            if (documentInfo && documentInfo.data && statusCode === 200) {
                let showCircle = (documentInfo.data.document && documentInfo.data.document.obligatory) ? documentInfo.data.document.obligatory : false
                let formatTransaction = (documentInfo.data.document && documentInfo.data.document.amount && documentInfo.data.document.amount > 0) ? `$${changeFormatNumberToShow(documentInfo.data.document.amount, 1)}` : '$0.0'
                let formatPenaltyFee = (documentInfo.data.document && documentInfo.data.document.penaltyFee === true) ? true : false
                let decryptUrl = ''
                let versions = []
                let versionSelected = {}
                let fileType = 'pdf'

                let signedInGovo = documentInfo.data.signedInGovo


                let asn1Decode = []
                const isAsn1OctetFile = (expediente, ENV) => {
                    return (
                        expediente.fileType === ENV.REACT_APP_OCTET_STREAM_TYPE &&
                        expediente.extension === ENV.REACT_APP_ASN1_EXTENSION
                    )
                }

                if (documentInfo.data.expediente?.length) {
                    documentInfo.data.expediente.map((expediente) => {
                        expediente.asn1Parse = {}

                        if (isAsn1OctetFile(expediente, this.ENV)) {
                            expediente.asn1Parse = {
                                localityName: expediente.detail?.localityName,
                                stateOrProvinceName: expediente.detail?.stateOrProvinceName,
                                countryName: expediente.detail?.countryName,
                                postalCode: expediente.detail?.postalCode,
                                streetAddress: expediente.detail?.streetAddress,
                                commonName: expediente.detail?.commonName,
                                organizationalUnitName: expediente.detail?.organizationalUnitName,
                                organizationName: expediente.detail?.organizationName,
                                emailAddress: expediente.detail?.emailAddress,
                                cRLDistributionPoints: expediente.detail?.cRLDistributionPoints,
                                certificatePolicies: expediente.detail?.certificatePolicies,
                                pscTimeValidated: expediente.detail?.pscTimeValidated,
                                signingTime: expediente.detail?.signingTime,
                            }
                        }

                        return expediente
                    })

                    const asn1FileOne = documentInfo.data.expediente.find((expediente) =>
                        isAsn1OctetFile(expediente, this.ENV)
                    )

                    asn1Decode = asn1FileOne?.asn1Parse ? [asn1FileOne.asn1Parse] : []
                }

                let filesDocument = []
                if (documentInfo.data.document.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
                    let file = (documentInfo.data.expediente?.length) ? documentInfo.data.expediente[0] : null
                    decryptUrl = (file && file.url && file.url !== '') ? decryptMessageBoveda(file.url) : ''
                    fileType = file && file.fileType

                    let versionsFile = (documentInfo.data.expediente?.length > 0 && documentInfo.data.expediente?.[0]?.versions) ? documentInfo.data.expediente[0].versions : []
                    versions = versionsFile
                    versionSelected = file

                    filesDocument = (documentInfo.data.expediente && documentInfo.data.expediente.length > 0) ? documentInfo.data.expediente : []
                } else {
                    decryptUrl = (documentInfo.data.document && documentInfo.data.document.url && documentInfo.data.document.url !== '') ? decryptMessageBoveda(documentInfo.data.document.url) : ''
                    versions = (documentInfo.data.versions && documentInfo.data.versions.length > 0) ? documentInfo.data.versions : []
                    if (versions.length > 0) {
                        versions = versions.map((version) => {
                            version.iconTrashActive = (version.statusType !== process.env.REACT_APP_FILE_STATUS_MAIN_DOC)
                            return version
                        })
                        let versionMain = versions.find((version) => version.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_DOC)
                        versionSelected = (versionMain) ? versionMain : {}
                    } else {
                        versionSelected = {}
                    }

                    filesDocument = (documentInfo.data.versions && documentInfo.data.versions.length > 0) ? documentInfo.data.versions : []

                    const file = (filesDocument && filesDocument.length > 0) ? filesDocument.find(file => file.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_DOC) : null

                    decryptUrl = (file && file.url && file.url !== '') ? decryptMessageBoveda(file.url) : ''
                    fileType = file && file.fileType
                }

                const isDeleted = (
                    documentInfo.data.document.status === this.ENV.REACT_APP_DOCUMENT_STATUS_ELIMINADO ||
                    documentInfo.data.document.status === this.ENV.REACT_APP_DOCUMENT_STATUS_ELIMINADO_PERMANENTEMENTE
                )

                const showPanelActions = this.state.fromDelete ? true : !isDeleted
                const showVersionsBtns = !isDeleted
                const showExpediente = (
                    documentInfo.data.document?.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
                )

                const filesExpediente = documentInfo.data.expediente || []
                let showVersions = documentInfo.data.versions?.length > 0

                const fileExpSelected = (
                    documentInfo.data.expediente?.length
                        ? documentInfo.data.expediente[0]
                        : {}
                )

                if (documentInfo.data.document.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE && documentInfo.data.expediente && documentInfo.data.expediente.length > 0 && documentInfo.data.expediente[0].versions && documentInfo.data.expediente[0].versions.length > 0) {
                    showVersions = true
                }

                //Verify if is Exp to show btn to upload a new file
                let showBtnAddDocumentToExp = (documentInfo.data.document?.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) ? true : false

                //Verify if document has entities
                let entitiesBD = (documentInfo.data.document && documentInfo.data.document.entities) ? documentInfo.data.document.entities : []
                if (entitiesBD && entitiesBD[0] && Object.keys(entitiesBD).length === 1) {
                    if (Object.keys(entitiesBD[0]).length > 0) entitiesBD = entitiesBD[0]
                }
                let entities = parseEntities(entitiesBD, this.props.t)
                entities = entities.sort((a, b) => a.type.toLowerCase().localeCompare(b.type.toLowerCase()))
                const entitiesStatus = (documentInfo.data.document && documentInfo.data.document.entitiesStatus) ? documentInfo.data.document.entitiesStatus : ''
                const showPanelEntities = documentInfo.data.document.infoType !== this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE && fileType === 'pdf'
                let showBtnExtractEntities = entitiesStatus ? false : true
                const preferenceIA = await this.getClientPreferences()
                if (preferenceIA === this.ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ENABLE) showBtnExtractEntities = false

                // Check if document is an expediente
                const isExpediente = (documentInfo.data && documentInfo.data.document && documentInfo.data.document.infoType) === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE

                // Set left panel visibility flags for expedientes
                const showLeftDownload = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.download) ? true : false
                const showShareLeft = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.share) ? true : false
                const showDeleteLeft = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.delete) ? true : false
                let showEditLeft = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.edit) ? true : false
                const showBtnDeleteDocDeExp = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.delete) ? true : false

                // Set default permissions
                let permissions = documentInfo.data.permissions || {
                    alerts: true,
                    edit: true,
                    print: true,
                    download: true,
                    send: true,
                    share: true,
                    delete: true,
                    version: true
                }

                // Override permissions for expedientes
                if (isExpediente) {
                    permissions = {
                        ...permissions,
                        alerts: false,
                        send: false,
                        share: false,
                        delete: false,
                        version: false
                    }
                }

                try {
                    const roles = (this.user && this.user.userMetaData && Array.isArray(this.user.userMetaData.userRoles)) ? this.user.userMetaData.userRoles : []
                    const isSuperAdmin = roles.some(r => (r && r.role && (r.role.key === process.env.REACT_APP_ADMIN || r.role.key === 'roleHibouAdministrator')))
                    const isVaultAdmin = roles.some(r => (r && r.role && (r.role.key === process.env.REACT_APP_ADMIN_DIGITAL_VAULT || r.role.key === 'roleHibouDigitalVaultAdministrator')))

                    const canEdit = isSuperAdmin || isVaultAdmin

                    permissions = { ...permissions, edit: !!canEdit }
                    showEditLeft = (!!canEdit) && (!!showEditLeft || !isExpediente)
                } catch (_) { }

                documentInfo.data.document.variables = documentInfo.data.document.variables.map(variable => {
                    if (!variable.value) return variable
                    variable.iconTrashActive = true
                    if (variable.typeData === 'boolean') {
                        variable.convertedValue = variable.value
                    } else {
                        variable.convertedValue = this.formatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                    }
                    return variable
                })

                this.setState({
                    documentData: documentInfo.data.document,
                    documentOwnerId: documentInfo.data.document?.userId || null,
                    signedInGovo,
                    showCircle,
                    formatTransaction,
                    formatPenaltyFee,
                    variables: documentInfo.data.document.variables,
                    ...((!this.state.isExternalUserView || !this.state.fileExpSelected?.id) && {
                        url: decryptUrl,
                        fileType,
                        asn1Decode
                    }),
                    permissions,
                    showActions: showPanelActions,
                    showVersions,
                    versions,
                    showVersionsBtns,
                    showExpediente,
                    filesExpediente,
                    fileExpSelected,
                    versionSelected,
                    showBtnAddDocumentToExp,
                    entities,
                    entitiesStatus,
                    filesDocument,
                    showPanelEntities,
                    showLeftDownload,
                    showShareLeft,
                    showDeleteLeft,
                    showEditLeft,
                    showBtnDeleteDocDeExp,
                    showBtnExtractEntities
                })

                await Promise.all([
                    this.getTypesDocumentsVariables(),
                    this.getDocumentAlerts(),
                    this.getDocumentTypes()
                ]).catch(error => {
                    console.warn('Error loading additional document data:', error)
                })

                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                const isPermissionError = Number(documentInfo?.statusCode) === Number(process.env.REACT_APP_DIGITAL_VAULT_ROLE_QUERY) || Number(documentInfo?.statusCode) === process.env.REACT_APP_DIGITAL_TRACKING_DENIED_ACCESS
                if (isPermissionError) {
                    this.setState({
                        showNoAccessModal: true,
                        noAccessMessage: this.props.t('digitalVaultView.noAccessMessage'),
                        isLoading: false,
                        dataLoaded: true
                    }, () => {
                    })
                    return true
                } else {
                    this.toggleErrorRequesting(messageError, 4000, true, '/')
                }
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.setState({
                showNoAccessModal: true,
                noAccessMessage: this.props.t('digitalVaultView.noAccessMessage'),
                isLoading: false,
                dataLoaded: true
            }, () => {
            })
        } finally {
            this.loadingDocumentData = false
        }
    }

    // Restaurar desde la Papelera
    handleRestoreDocument = async () => {
        try {
            this.toggleLoadingRequesting(true)
            const isDeletingDocument = !!this.props.isDeletingDocument
            let response

            if (!isDeletingDocument) {
                response = await this.digitalVaultDocumentService.updateDocumentStatus(this.id, this.ENV.REACT_APP_DOCUMENT_ACTION_RESTORE, this.token)
            } else {
                response = await this.digitalVaultService.nextDeleteWorkflowStep(this.id, this.token, false)
            }

            if (response && (response.statusCode === 200 || response.statusCode === 201)) {
                this.toggleCompletedRequesting(7000, true, '/', this.props.t("dialogSystemGLPure.restoredDocument.title"), this.props.t("dialogSystemGLPure.restoredDocument.message"))
            } else {
                throw new Error(response?.message || 'Error al restaurar el documento')
            }
        } catch (error) {
            this.toggleErrorRequesting(error.message || 'Error al restaurar el documento', 4000, false, '', 'Error al Restaurar')
        } finally {
            this.toggleLoadingRequesting(false)
        }
    }

    // Eliminar permanentemente desde Papelera
    handleDeletePermanently = async () => {
        try {
            this.toggleLoadingRequesting(true)
            const isDeletingDocument = !!this.props.isDeletingDocument
            let response

            if (!isDeletingDocument) {
                response = await this.digitalVaultService.startDeleteWorkflow(this.id, true, this.token)
            } else {
                response = await this.digitalVaultService.nextDeleteWorkflowStep(this.id, this.token, true)
            }

            if (response && (response.statusCode === 200 || response.statusCode === 201)) {
                this.toggleCompletedRequesting(7000, true, '/', this.props.t("dialogSystemGLPure.documentDeleted.title"), this.props.t("dialogSystemGLPure.documentDeleted.message"))
            } else {
                throw new Error(response?.message || 'Error al eliminar el documento')
            }
        } catch (error) {
            this.toggleErrorRequesting(error.message || 'Error al eliminar el documento', 4000, false, '', 'Error al Eliminar')
        } finally {
            this.toggleLoadingRequesting(false)
        }
    }


    getBinnacle = async () => {
        if (this.loadingBinnacle) {
            console.warn('getBinnacle already in progress, skipping duplicate call')
            return
        }
        this.loadingBinnacle = true
        let messageError = 'Ocurrió un error al consultar la infomación de la bitácora del documento'
        let clientId = this.user.userMetaData.userA3Cloud.clientId

        try {
            let binnacleBD = await this.documentLogsService.getDocumentLogs(clientId, this.timezone, this.token, this.id)

            if (binnacleBD && Number(binnacleBD.statusCode) === Number(process.env.REACT_APP_DIGITAL_TRACKING_DENIED_ACCESS)) {
                this.toggleLoadingView(false)
                this.setState({
                    showNoAccessModal: true,
                    noAccessMessage: this.props.t('digitalVaultView.noAccessMessage')
                }, () => {
                })
                this.loadingBinnacle = false
                return
            }
            if (binnacleBD && binnacleBD.data && Number(binnacleBD.statusCode) === 200) {
                const mapLogEntry = (register, moduleType) => {
                    let binnacleInfo = {}
                    binnacleInfo.id = register.id
                    binnacleInfo.date = register.newDate
                    binnacleInfo.sending = register.sending
                    binnacleInfo.sharing = register.sharing
                    binnacleInfo.categoryId = register.categoryId
                    binnacleInfo.subcategoryId = register.subcategoryId
                    binnacleInfo.clientId = register.clientId
                    binnacleInfo.name = this.props.t(`digitalVaultStatisticalReportView.key.${register.documentAction.name}`)
                    binnacleInfo.documentActionId = register.documentAction.id
                    binnacleInfo.nameUser = register.user.email
                    binnacleInfo.userId = register.user.id

                    // Assign moduleId and moduleName based on the log type
                    switch (moduleType) {
                        case 'contractLogs':
                            binnacleInfo.moduleId = 1
                            binnacleInfo.moduleName = this.props.t('documentPanelBarBinnacle.modules.contracts')
                            break
                        case 'documentLogs':
                            binnacleInfo.moduleId = 2
                            binnacleInfo.moduleName = this.props.t('documentPanelBarBinnacle.modules.digitalVault')
                            break
                        case 'negotiationLogs':
                            binnacleInfo.moduleId = 3
                            binnacleInfo.moduleName = this.props.t('documentPanelBarBinnacle.modules.negotiation')
                            break
                        case 'signRequestLogs':
                            binnacleInfo.moduleId = 4
                            binnacleInfo.moduleName = this.props.t('documentPanelBarBinnacle.modules.digitalSignature')
                            break
                        default:
                            binnacleInfo.moduleId = null
                            binnacleInfo.moduleName = '-'
                    }

                    return binnacleInfo
                }

                // Concatenate all logs from different modules
                let allLogs = []

                // The correct structure is binnacleBD.data.documentLogs.{type}
                const logsContainer = binnacleBD.data.documentLogs

                if (logsContainer.documentLogs && Array.isArray(logsContainer.documentLogs)) {
                    try {
                        const mapped = logsContainer.documentLogs.map(log => mapLogEntry(log, 'documentLogs'))
                        allLogs = allLogs.concat(mapped)
                    } catch (err) {
                        throw new Error('Error al mapear documentLogs:', err)
                    }
                }

                if (logsContainer.contractLogs && Array.isArray(logsContainer.contractLogs)) {
                    try {
                        const mapped = logsContainer.contractLogs.map(log => mapLogEntry(log, 'contractLogs'))
                        allLogs = allLogs.concat(mapped)
                    } catch (err) {
                        throw new Error('Error al mapear contractLogs:', err)
                    }
                }

                if (logsContainer.negotiationLogs && Array.isArray(logsContainer.negotiationLogs)) {
                    try {
                        const mapped = logsContainer.negotiationLogs.map(log => mapLogEntry(log, 'negotiationLogs'))
                        allLogs = allLogs.concat(mapped)
                    } catch (err) {
                        throw new Error('Error al mapear negotiationLogs:', err)
                    }
                }

                if (logsContainer.signRequestLogs && Array.isArray(logsContainer.signRequestLogs)) {
                    try {
                        const mapped = logsContainer.signRequestLogs.map(log => mapLogEntry(log, 'signRequestLogs'))
                        allLogs = allLogs.concat(mapped)
                    } catch (err) {
                        throw new Error('Error al mapear signRequestLogs:', err)
                    }
                }

                // Process available actions
                binnacleBD.data.documentActions = binnacleBD.data.documentActions.filter(item => {
                    if (!item.name || item.name === 'null' || item.name.trim() === '') {
                        return false
                    }
                    return true
                })

                binnacleBD.data.documentActions = binnacleBD.data.documentActions.map(item => {
                    item.name = this.props.t(`digitalVaultStatisticalReportView.key.${item.name}`)
                    return item
                })
                const actionOptions = [{ id: 0, name: this.props.t('documentPanelBarBinnacle.allActions') }, ...binnacleBD.data.documentActions]
                this.setState({
                    binnacle: allLogs,
                    actionOptions
                })
            } else {
                this.toggleLoadingView(false)
                const isPermissionError = Number(binnacleBD?.statusCode) === Number(process.env.REACT_APP_DIGITAL_VAULT_ROLE_QUERY) || Number(binnacleBD?.statusCode) === Number(process.env.REACT_APP_DIGITAL_TRACKING_DENIED_ACCESS)
                if (isPermissionError) {
                    this.setState({
                        showNoAccessModal: true,
                        noAccessMessage: this.props.t('digitalVaultView.noAccessMessage')
                    }, () => {
                    })
                } else {
                    this.toggleErrorRequesting(messageError, 4000, false, '/')
                }
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        } finally {
            this.loadingBinnacle = false
        }
    }

    getUsersCollabs = async () => {
        if (this.state.isExternalUserView) {
            return
        }
        if (this.loadingUsersCollabs) {
            console.warn('getUsersCollabs already in progress, skipping duplicate call')
            return
        }
        this.loadingUsersCollabs = true
        let messageError = 'Ocurrió un error al consultar los usuarios invitados'
        try {
            let usersCollabotartorsList = await this.userService.getUsersToShareDocuments(this.token)
            if (usersCollabotartorsList.statusCode === 200 && usersCollabotartorsList.data) {
                this.setState({
                    userCollaborators: usersCollabotartorsList.data,
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        } finally {
            this.loadingUsersCollabs = false
        }
    }

    getDocumentMessages = async () => {
        try {
            // Leer workflowExecutionExternalId de la URL
            const searchParams = new URLSearchParams(window.location.search)
            const hash = window.location.hash || ''
            const queryString = hash.includes('?') ? hash.split('?')[1] : ''
            const hashParams = new URLSearchParams(queryString)
            const workflowExecutionExternalId = hashParams.get('workflowExecutionExternalId') || searchParams.get('workflowExecutionExternalId')

            // Si no hay workflowExecutionExternalId en la URL, no cargar mensajes
            if (!workflowExecutionExternalId) {
                return
            }

            const response = await this.digitalVaultDocumentService.getDocumentMessages(
                workflowExecutionExternalId,
                this.timezone,
                this.token
            )

            if (response && response.statusCode === 200) {
                const { workflowExecutionMembers = [], workflowExecutionMessages = [] } = response.data || {}

                const membersChat = workflowExecutionMembers.filter((member, index) =>
                    workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
                )

                let user = {}
                membersChat.map((member) => {
                    member.id = member.workflowExecutionMemberId
                    member.avatarUrl = member.profilePicture
                    member.name = `${member.firstName || ''} ${member.firstLastName || ''}`.trim()
                    member.avatarAltText = member.name

                    if (this.user.userMetaData && this.user.userMetaData.userA3Cloud &&
                        this.user.userMetaData.userA3Cloud.email === member.email) {
                        this.idAuthorMessage = member.id
                        user = member
                    }
                    return member
                })

                if (!user.id && membersChat.length > 0) {
                    user = membersChat[0]
                    this.idAuthorMessage = user.id
                }

                const conversation = workflowExecutionMessages.map((msg) => {
                    msg.author = {
                        name: `${msg.firstName || ''} ${msg.firstLastName || ''}`.trim(),
                        id: msg.workflowExecutionMemberId,
                        avatarUrl: msg.profilePicture
                    }
                    msg.timestamp = new Date(msg.createdDate)
                    msg.text = msg.workflowExecutionMemberMessage
                    msg.id = msg.workflowExecutionMemberId
                    msg.name = `${msg.firstName || ''} ${msg.firstLastName || ''}`.trim()
                    msg.avatarUrl = msg.profilePicture

                    if (msg.workflowExecutionMemberMessageDoc && msg.workflowExecutionMemberMessageDoc.length > 0) {
                        msg.attachments = [{
                            name: msg.workflowExecutionMemberMessageDoc[0]?.documentName,
                            site: msg.workflowExecutionMemberMessageDoc[0]?.documentPath
                        }]
                    }

                    return msg
                })

                this.setState({
                    usersChat: user,
                    conversation,
                    membersChat
                })
            }
        } catch (error) {
            console.error('Error al obtener mensajes del chat:', error)
        }
    }

    /**
     * @function sendPendingUploadNotifications
     * @description Envía notificaciones por correo para documentos subidos (UPLOADED) cuando el usuario sale
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    sendPendingUploadNotifications = async () => {
        if (this.uploadedDocumentsPendingNotification.size === 0) return

        const recipientIds = Array.from(this.uploadedDocumentsPendingNotification)

        for (const recipientId of recipientIds) {
            try {
                await this.digitalVaultDocumentService.sendExternalDocumentNotification(
                    this.id,
                    recipientId,
                    process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_UPLOADED,
                    this.token
                )
            } catch (error) {
                console.error(`Error enviando notificación UPLOADED para recipientId ${recipientId}:`, error)
            }
        }

        // Limpiar tracking
        this.uploadedDocumentsPendingNotification.clear()
    }

    /**
     * @function getExternalDocuments
     * @description Obtiene los documentos externos solicitados a usuarios terceros
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    getExternalDocuments = async () => {
        if (this.loadingExternalDocuments) {
            return
        }
        this.loadingExternalDocuments = true
        const messageError = 'Ocurri\u00f3 un error al consultar los documentos externos'

        try {
            const response = await this.digitalVaultDocumentService.getExternalDocuments(
                this.id,
                this.token
            )

            if (response && response.statusCode === 200 && response.data) {
                const { usersDocuments = [], userIsApplicant = false, userIsValidator = false, userIsShared = false, infoType = 'Documento', documentLimit = 10, limitDate = '', user = {}, statusCurrent = null } = response.data

                // Extraer instructions del primer userDoc
                const instructions = (usersDocuments.length > 0 && usersDocuments[0].instructions) ? usersDocuments[0].instructions : ''

                // Transformar los datos al formato del grid
                const transformedDocuments = this.transformExternalDocumentsToGrid(usersDocuments, userIsApplicant)

                this.setState({
                    externalDocuments: transformedDocuments,
                    userIsApplicant: userIsApplicant,
                    userIsValidator: userIsValidator,
                    userIsShared: userIsShared,
                    externalDocumentsLoaded: true,
                    externalDocumentsInfoType: infoType,
                    externalDocumentsLimit: documentLimit,
                    externalDocumentsLimitDate: limitDate,
                    externalDocumentsInstructions: instructions,
                    usersDocumentsRaw: usersDocuments,
                    externalDocumentsCurrentUserId: user.id || null,
                    externalDocumentsStatusCurrent: statusCurrent || null
                }, () => {
                    const firstUploadedDoc = transformedDocuments.find(doc =>
                        doc.status === 'Cargado' || doc.status === 'UPLOADED'
                    )
                    if (firstUploadedDoc) {
                        this.handleSelectFileExp(firstUploadedDoc)
                    } else {
                        console.warn('[getExternalDocuments] No hay documentos cargados para auto-seleccionar')
                    }
                })

                // Retornar los datos crudos para que el caller pueda verificar el estado real
                return usersDocuments
            }

            return []
        } catch (error) {
            console.error('Error al obtener documentos externos:', error)
            this.toggleErrorRequesting(messageError, 4000, false, '', this.props.t('digitalVaultDocumentView.titleError'))
            return []
        } finally {
            this.loadingExternalDocuments = false
        }
    }

    /**
     * @function transformExternalDocumentsToGrid
     * @description Transforma los documentos externos al formato esperado por el grid
     * @param {Array} usersDocuments - Documentos de usuarios externos (del backend viene 'usersDocuments')
     * @param {boolean} userIsApplicant - Si el usuario actual es el solicitante
     * @returns {Array} Documentos transformados
     * @memberof DigitalVaultDocumentAction
     */
    transformExternalDocumentsToGrid = (usersDocuments, userIsApplicant) => {
        if (!Array.isArray(usersDocuments)) {
            return []
        }

        const gridDocuments = []

        usersDocuments.forEach(userDoc => {
            const { userEmail, userId, documents = [], isFreeLoad = false, recipientId, documentName } = userDoc

            const isFreeLoadDetected = isFreeLoad || (documents.length > 0 && documents.some(doc => doc.templateId === null))

            // Caso 1: Carga libre (isFreeLoad = true)
            if (isFreeLoadDetected) {
                if (documents.length > 0) {
                    documents.forEach(doc => {
                        const statusMap = {
                            'PENDING': 'Pendiente',
                            'UPLOADED': 'Cargado',
                            'ACCEPTED': 'Aceptado',
                            'REJECTED': 'Rechazado',
                            'EN_BOVEDA': 'Aceptado'
                        }

                        const gridItem = {
                            id: doc.id,
                            recipientId: recipientId,
                            name: doc.documentTemplateName || null,
                            status: statusMap[doc.status] || 'Pendiente',
                            statusDate: doc.updatedDate || doc.createdDate || null,
                            document: doc.url ? {
                                id: doc.id,
                                name: doc.documentTemplateName || doc.fileName || 'Documento',
                                url: doc.url
                            } : null,
                            selected: false,
                            userEmail: userEmail,
                            userId: userId,
                            comments: doc.comments,
                            templateId: doc.templateId,
                            typeDocumentId: doc.typeDocumentId,
                            scope: doc.documentTemplateScope,
                            isFreeLoad: true,
                            requestItemId: doc.id,
                            mimeType: doc.mimeType || null
                        }
                        gridDocuments.push(gridItem)
                    })
                } else {
                    const emptyGridItem = {
                        id: null,
                        recipientId: recipientId,
                        name: null,
                        status: 'Pendiente',
                        statusDate: null,
                        document: null,
                        selected: false,
                        userEmail: userEmail,
                        userId: userId,
                        comments: null,
                        rejectionReason: null,
                        templateId: null,
                        requestItemId: null,
                        typeDocumentId: null,
                        scope: null,
                        isFreeLoad: true,
                        mimeType: null
                    }
                    gridDocuments.push(emptyGridItem)
                }
            } else {
                // Caso 2: Documentos requeridos (flujo normal)
                documents.forEach(doc => {
                    const statusMap = {
                        'PENDING': 'Pendiente',
                        'UPLOADED': 'Cargado',
                        'ACCEPTED': 'Aceptado',
                        'REJECTED': 'Rechazado',
                        'EN_BOVEDA': 'Aceptado'
                    }

                    const gridItem = {
                        id: doc.id,
                        recipientId: recipientId,
                        name: doc.documentTemplateName || null,
                        status: statusMap[doc.status] || 'Pendiente',
                        statusDate: doc.updatedDate || doc.updatedDate || doc.createdDate || null,
                        document: doc.url ? {
                            id: doc.id,
                            name: doc.documentTemplateName,
                            url: doc.url
                        } : null,
                        selected: false,
                        userEmail: userEmail,
                        userId: userId,
                        comments: doc.comments,
                        templateId: doc.templateId,
                        typeDocumentId: doc.typeDocumentId,
                        scope: doc.documentTemplateScope,
                        isFreeLoad: false,
                        requestItemId: doc.id,
                        mimeType: doc.mimeType || null
                    }

                    gridDocuments.push(gridItem)
                })
            }
        })

        return gridDocuments
    }

    /**
     * @function handleUploadExternalDocument
     * @description Maneja la subida de un documento externo
     * @param {Object} dataItem - Item del grid con la información del documento a cargar
     * @param {File} fileToUpload - Archivo a subir (opcional, si no se pasa se abre selector)
     * @param {Boolean} isApplicant - Si el usuario es el solicitante (true) o un tercero (false)
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    handleUploadExternalDocument = async (dataItem, fileToUpload = null, isApplicant = false) => {
        // Si se pasa un archivo directamente, procesarlo
        if (fileToUpload) {
            this.toggleLoadingRequesting(true)
            const messageError = 'Ocurrió un error al cargar el documento'

            try {
                // Preparar FormData
                const formData = new FormData()
                formData.append('document', fileToUpload)
                formData.append('documentId', this.id)
                formData.append('recipientId', dataItem.recipientId)
                formData.append('isApplicant', isApplicant.toString())

                if (dataItem.templateId !== null && dataItem.templateId !== undefined) {
                    formData.append('templateId', dataItem.templateId)
                }

                if (dataItem.requestItemId !== null && dataItem.requestItemId !== undefined) {
                    formData.append('requestItemId', dataItem.requestItemId)
                }

                // Llamar al servicio
                const response = await this.digitalVaultDocumentService.uploadExternalDocument(
                    formData,
                    this.token
                )

                if (response && response.statusCode === 200) {
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(
                        4000,
                        false,
                        '',
                        this.props.t('digitalVaultDocumentView.titleSuccess'),
                        'Documento cargado exitosamente'
                    )

                    if (dataItem.recipientId) {
                        this.uploadedDocumentsPendingNotification.add(dataItem.recipientId)
                    }

                    await this.getExternalDocuments()
                } else {
                    this.toggleLoadingRequesting(false)
                    this.toggleErrorRequesting(
                        messageError,
                        4000,
                        false,
                        '',
                        this.props.t('digitalVaultDocumentView.titleError')
                    )
                }
            } catch (error) {
                console.error('Error al cargar documento externo:', error)
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(
                    messageError,
                    4000,
                    false,
                    '',
                    this.props.t('digitalVaultDocumentView.titleError')
                )
            }
            return
        }

        const input = document.createElement('input')
        input.type = 'file'
        input.accept = '.pdf,.doc,.docx,.jpg,.jpeg,.png'

        input.onchange = async (e) => {
            const file = e.target.files[0]
            if (!file) return

            this.toggleLoadingRequesting(true)
            const messageError = 'Ocurrió un error al cargar el documento'

            try {
                // Preparar FormData
                const formData = new FormData()
                formData.append('document', file)
                formData.append('documentId', this.id)
                formData.append('recipientId', dataItem.recipientId)
                formData.append('isApplicant', isApplicant.toString())

                if (dataItem.templateId !== null && dataItem.templateId !== undefined) {
                    formData.append('templateId', dataItem.templateId)
                }

                if (dataItem.requestItemId !== null && dataItem.requestItemId !== undefined) {
                    formData.append('requestItemId', dataItem.requestItemId)
                }

                // Llamar al servicio
                const response = await this.digitalVaultDocumentService.uploadExternalDocument(
                    formData,
                    this.token
                )

                if (response && response.statusCode === 200) {
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(
                        4000,
                        false,
                        '',
                        this.props.t('digitalVaultDocumentView.titleSuccess'),
                        'Documento cargado exitosamente'
                    )

                    if (dataItem.recipientId) {
                        this.uploadedDocumentsPendingNotification.add(dataItem.recipientId)
                    }

                    await this.getExternalDocuments()
                } else {
                    this.toggleLoadingRequesting(false)
                    this.toggleErrorRequesting(
                        messageError,
                        4000,
                        false,
                        '',
                        this.props.t('digitalVaultDocumentView.titleError')
                    )
                }
            } catch (error) {
                console.error('Error al cargar documento externo:', error)
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(
                    messageError,
                    4000,
                    false,
                    '',
                    this.props.t('digitalVaultDocumentView.titleError')
                )
            }
        }

        // Abrir el selector de archivos
        input.click()
    }

    /**
     * @function handleDeleteExternalDocument
     * @description Maneja la eliminación de un documento externo solicitado
     * @param {Object} dataItem - Item del grid con la información del documento a eliminar
     * @param {String} rejectionComments - Motivo de rechazo (opcional, si se proporciona envía notificación REJECTED)
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    handleDeleteExternalDocument = async (dataItem, rejectionComments = '') => {
        const { t } = this.props

        if (!dataItem || !dataItem.recipientId || !dataItem.requestItemId) {
            this.toggleErrorRequesting(
                t('documentPanelBarDocumentRequested.delete.error.message', {
                    defaultValue: 'Error: Datos insuficientes para eliminar el documento'
                }),
                5000,
                false,
                '',
                t('documentPanelBarDocumentRequested.delete.error.title', { defaultValue: 'Error' })
            )
            return
        }

        this.toggleLoadingRequesting(true)

        try {
            const response = await this.digitalVaultDocumentService.deleteExternalDocument(
                this.id,
                dataItem.recipientId,
                dataItem.requestItemId,
                this.token
            )

            if (response && response.statusCode === 200) {
                this.toggleLoadingRequesting(false)

                const successMessage = rejectionComments
                    ? t('documentPanelBarDocumentRequested.reject.success.message', {
                        defaultValue: 'El documento ha sido rechazado y eliminado correctamente'
                    })
                    : t('documentPanelBarDocumentRequested.delete.success.message', {
                        defaultValue: 'El documento ha sido eliminado correctamente'
                    })

                this.toggleCompletedRequesting(
                    3000,
                    false,
                    '',
                    t('documentPanelBarDocumentRequested.delete.success.title', { defaultValue: 'Govo' }),
                    successMessage
                )

                await this.getExternalDocuments()
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(
                    response?.message || t('documentPanelBarDocumentRequested.delete.error.message', {
                        defaultValue: 'Ocurrió un error al eliminar el documento'
                    }),
                    5000,
                    false,
                    '',
                    t('documentPanelBarDocumentRequested.delete.error.title', { defaultValue: 'Error' })
                )
            }
        } catch (error) {
            console.error('Error deleting external document:', error)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(
                t('documentPanelBarDocumentRequested.delete.error.message', {
                    defaultValue: 'Ocurrió un error al eliminar el documento'
                }),
                5000,
                false,
                '',
                t('documentPanelBarDocumentRequested.delete.error.title', { defaultValue: 'Error' })
            )
        }
    }

    /**
     * @function handleExternalDocumentAction
     * @description Maneja las acciones sobre documentos externos (aceptar, rechazar, marcar requerido/no requerido)
     * @param {Object} document - Documento sobre el cual se realizará la acción
     * @param {String} action - Acción a realizar: 'ACCEPTED', 'REJECTED', 'REQUIRED'
     * @param {Boolean} required - Si el documento es requerido (solo para action='REQUIRED')
     * @param {String} comments  - Motivo de rechazo (solo para action='REJECTED')
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    handleExternalDocumentAction = async (document, action, required = false, comments = '') => {
        const { t } = this.props

        // Validaciones
        if (!document || !document.recipientId || !document.requestItemId) {
            this.toggleErrorRequesting(
                t('documentPanelBarDocumentRequested.action.error.invalidData', {
                    defaultValue: 'Error: Datos insuficientes para realizar la acción'
                }),
                5000,
                false,
                '',
                t('documentPanelBarDocumentRequested.action.error.title', { defaultValue: 'Error' })
            )
            return
        }

        // Validar que la acción sea válida
        const validActions = [
            process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_ACCEPTED,
            process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_REJECTED,
            process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_REQUIRED
        ]
        if (!validActions.includes(action)) {
            this.toggleErrorRequesting(
                t('documentPanelBarDocumentRequested.action.error.invalidAction', {
                    defaultValue: 'Error: Acción no válida'
                }),
                5000,
                false,
                '',
                t('documentPanelBarDocumentRequested.action.error.title', { defaultValue: 'Error' })
            )
            return
        }

        // Validar estado del documento según la acción
        if (action === process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_ACCEPTED || action === process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_REJECTED) {
            if (document.status !== process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_UPLOADED) {
                this.toggleErrorRequesting(
                    t('documentPanelBarDocumentRequested.action.error.mustBeUploaded', {
                        defaultValue: 'El documento debe estar en estado "Cargado" para aceptar o rechazar'
                    }),
                    5000,
                    false,
                    '',
                    t('documentPanelBarDocumentRequested.action.error.title', { defaultValue: 'Error' })
                )
                return
            }
        }

        this.toggleLoadingRequesting(true)

        try {
            const response = await this.digitalVaultDocumentService.performExternalDocumentAction(
                this.id,
                document.recipientId,
                document.requestItemId,
                action,
                required,
                this.token,
                comments
            )

            if (response && response.statusCode === 200) {

                // Mensajes de éxito según la acción
                let successMessage = ''
                switch (action) {
                    case 'ACCEPTED':
                        successMessage = t('documentPanelBarDocumentRequested.action.success.accepted', {
                            defaultValue: 'El documento ha sido aceptado correctamente'
                        })
                        break
                    case 'REJECTED':
                        successMessage = t('documentPanelBarDocumentRequested.action.success.rejected', {
                            defaultValue: 'El documento ha sido rechazado correctamente'
                        })
                        break
                    case 'REQUIRED':
                        successMessage = required
                            ? t('documentPanelBarDocumentRequested.action.success.markedRequired', {
                                defaultValue: 'El documento ha sido marcado como requerido'
                            })
                            : t('documentPanelBarDocumentRequested.action.success.markedNotRequired', {
                                defaultValue: 'El documento ha sido marcado como no requerido'
                            })
                        break
                    default:
                        successMessage = t('documentPanelBarDocumentRequested.action.success.default', {
                            defaultValue: 'Acción realizada correctamente'
                        })
                }

                // Recargar primero y obtener datos frescos del API (no del estado, que es asíncrono)
                const freshUsersDocuments = await this.getExternalDocuments()

                // Verificar con datos frescos si todos quedaron completos
                // Si todos completan, el useEffect del hijo dispara handleCloseRequest (tiene su propio modal)
                // y NO debemos mostrar el modal de éxito individual para evitar modales superpuestos
                const allCompleted = Array.isArray(freshUsersDocuments) && freshUsersDocuments.length > 0 &&
                    freshUsersDocuments.every(userDoc =>
                        userDoc.documents &&
                        userDoc.documents.length > 0 &&
                        userDoc.documents.every(doc =>
                            doc.status === process.env.REACT_APP_EXTERNAL_DOCUMENTS_NOTIFICATION_TYPE_ACCEPTED ||
                            doc.status === 'EN_BOVEDA' ||
                            doc.required === false
                        )
                    )

                if (!allCompleted) {
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(
                        3000,
                        false,
                        '',
                        t('documentPanelBarDocumentRequested.action.success.title', { defaultValue: 'Govo' }),
                        successMessage
                    )
                }
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(
                    response?.message || t('documentPanelBarDocumentRequested.action.error.message', {
                        defaultValue: 'Ocurrió un error al realizar la acción'
                    }),
                    5000,
                    false,
                    '',
                    t('documentPanelBarDocumentRequested.action.error.title', { defaultValue: 'Error' })
                )
            }
        } catch (error) {
            console.error('Error performing external document action:', error)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(
                t('documentPanelBarDocumentRequested.action.error.message', {
                    defaultValue: 'Ocurrió un error al realizar la acción'
                }),
                5000,
                false,
                '',
                t('documentPanelBarDocumentRequested.action.error.title', { defaultValue: 'Error' })
            )
        }
    }


    /**
     * @function handleCancelRequest
     * @description Cancela la solicitud de documentos externos (defined: CANCELLED, statusUpdate: 320799)
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    handleCancelRequest = async () => {
        const { t } = this.props

        this.toggleLoadingRequesting(true)

        try {
            const response = await this.digitalVaultDocumentService.changeWorkflowGuestDocuments(
                this.id,
                'cancel',
                this.token
            )

            if (response && response.statusCode === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(
                    3000,
                    true,
                    '/',
                    t('documentPanelBarDocumentsRequested.cancelRequest.success.title', { defaultValue: 'Govo' }),
                    t('documentPanelBarDocumentsRequested.cancelRequest.success.message', {
                        defaultValue: 'La solicitud ha sido cancelada correctamente'
                    })
                )
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(
                    response?.message || t('documentPanelBarDocumentsRequested.cancelRequest.error.message', {
                        defaultValue: 'Ocurrió un error al cancelar la solicitud'
                    }),
                    5000,
                    false,
                    '',
                    t('documentPanelBarDocumentsRequested.cancelRequest.error.title', { defaultValue: 'Error' })
                )
            }
        } catch (error) {
            console.error('Error cancelling request:', error)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(
                t('documentPanelBarDocumentsRequested.cancelRequest.error.message', {
                    defaultValue: 'Ocurrió un error al cancelar la solicitud'
                }),
                5000,
                false,
                '',
                t('documentPanelBarDocumentsRequested.cancelRequest.error.title', { defaultValue: 'Error' })
            )
        }
    }

    /**
     * @function handleCloseRequest
     * @description Cierra la solicitud de documentos externos (next: null) o maneja acciones de validador (next/back)
     * @param {String} action - Acción a realizar: null/'close' (cerrar), 'next' (aprobar), 'back' (rechazar)
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    handleCloseRequest = async (action = 'close', comments = '') => {
        const { t } = this.props

        this.toggleLoadingRequesting(true)

        try {
            const response = await this.digitalVaultDocumentService.changeWorkflowGuestDocuments(
                this.id,
                action,
                this.token,
                comments
            )

            if (response && response.statusCode === 200) {
                this.toggleLoadingRequesting(false)

                let successTitle = ''
                let successMessage = ''

                if (action === 'next') {
                    successTitle = t('documentPanelBarDocumentsRequested.approveRequest.success.title')
                    successMessage = t('documentPanelBarDocumentsRequested.approveRequest.success.message')
                } else if (action === 'back') {
                    successTitle = t('documentPanelBarDocumentsRequested.rejectRequest.success.title')
                    successMessage = t('documentPanelBarDocumentsRequested.rejectRequest.success.message')
                } else {
                    successTitle = t('documentPanelBarDocumentsRequested.closeRequest.success.title')
                    successMessage = t('documentPanelBarDocumentsRequested.closeRequest.success.message')
                }

                this.toggleCompletedRequesting(
                    3000,
                    true,
                    '/',
                    successTitle,
                    successMessage
                )
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(
                    response?.message || t('documentPanelBarDocumentsRequested.closeRequest.error.message', {
                        defaultValue: 'Ocurrió un error al procesar la solicitud'
                    }),
                    5000,
                    false,
                    '',
                    t('documentPanelBarDocumentsRequested.closeRequest.error.title', { defaultValue: 'Error' })
                )
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(
                t('documentPanelBarDocumentsRequested.closeRequest.error.message', {
                    defaultValue: 'Ocurrió un error al procesar la solicitud'
                }),
                5000,
                false,
                '',
                t('documentPanelBarDocumentsRequested.closeRequest.error.title', { defaultValue: 'Error' })
            )
        }
    }

    /**
     * @function handleSendThirdPartyRequest
     * @description Envía una nueva solicitud de documentos a terceros desde un expediente completado (status 320730)
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    handleSendThirdPartyRequest = async () => {
        const { t } = this.props

        this.toggleLoadingRequesting(true)

        try {
            // 1. Obtener datos actuales del documento desde vault-document
            const documentResponse = await this.digitalVaultDocumentService.getDocumentById(
                this.id,
                this.token
            )

            if (!documentResponse || documentResponse.statusCode !== 200 || !documentResponse.data) {
                throw new Error('No se pudieron obtener los datos del documento')
            }

            const doc = this.state.documentData


            // 2. Preparar FormData según estructura de Postman
            const formData = new FormData()

            // Datos básicos del documento (de vault-document)
            formData.append('timezone', this.timezone || 'America/Mexico_City')
            formData.append('infoType', doc.infoType || 'Expediente')
            formData.append('name', doc.name || '')

            // typeDocument como JSON string
            if (doc.typeDocument) {
                const typeDocObj = typeof doc.typeDocument === 'string'
                    ? { name: doc.typeDocument }
                    : doc.typeDocument
                formData.append('typeDocument', JSON.stringify(typeDocObj))
            }

            // Archivos y AI
            formData.append('filesToAI', JSON.stringify([]))
            formData.append('sendFilesToAI', 'false')

            // 3. Agregar usuarios seleccionados con estructura correcta
            const usersArray = this.state.selectedUsers.map(user => {
                const userDocList = this.state.userDocumentLists[user.email] || []
                const userInstructions = this.state.userInstructions[user.email] || ''

                return {
                    id: user.id || null,
                    email: user.email,
                    documents: userDocList.map(doc => ({
                        id: doc.id || null,
                        name: doc.name || ''
                    })),
                    instructions: userInstructions || ''
                }
            })

            formData.append('users', JSON.stringify(usersArray))


            // Autorizador (si existe secondApprovalUser)
            formData.append('addAuthorizer', this.state.enableSecondApproval ? 'true' : 'false')
            if (this.state.enableSecondApproval && this.state.secondApprovalUser) {
                const authorizerObj = {
                    id: this.state.secondApprovalUser.id || null,
                    email: this.state.secondApprovalUser.email || ''
                }
                formData.append('authorizer', JSON.stringify(authorizerObj))
            }

            // Fecha de inicio (usar requestDeadline o validationDate del documento)
            const startDate = this.state.requestDeadline
                ? new Date(this.state.requestDeadline).toISOString().split('T')[0]
                : (doc.validationDate || new Date().toISOString().split('T')[0])
            formData.append('startDate', startDate)

            // Parámetros especiales para agregar documento a expediente existente
            formData.append('addDocument', 'true')
            formData.append('newDocument', JSON.stringify({ documentId: this.id }))

            // 4. Hacer POST a workflow-guest-documents
            const response = await this.digitalVaultDocumentService.createWorkflowGuestDocuments(
                formData,
                this.token
            )

            if (response && response.statusCode === 200) {
                this.toggleLoadingRequesting(false)

                this.toggleCompletedRequesting(
                    3000,
                    false,
                    '',
                    t('digitalVaultDocumentView.sendRequest.success.title', { defaultValue: 'Solicitud enviada' }),
                    t('digitalVaultDocumentView.sendRequest.success.message', { defaultValue: 'La solicitud de documentos ha sido enviada exitosamente' })
                )

                // Recargar datos externos para reflejar la nueva solicitud
                await this.getExternalDocuments()
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(
                    response?.message || t('digitalVaultDocumentView.sendRequest.error.message', {
                        defaultValue: 'Ocurrió un error al enviar la solicitud'
                    }),
                    5000,
                    false,
                    '',
                    t('digitalVaultDocumentView.sendRequest.error.title', { defaultValue: 'Error' })
                )
            }
        } catch (error) {
            console.error('Error al enviar solicitud de terceros:', error)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(
                t('digitalVaultDocumentView.sendRequest.error.message', {
                    defaultValue: 'Ocurrió un error al enviar la solicitud'
                }),
                5000,
                false,
                '',
                t('digitalVaultDocumentView.sendRequest.error.title', { defaultValue: 'Error' })
            )
        }
    }

    handleInputChangeChat = (event) => {
    }


    createMessage = async (messagesChat, fileContent) => {
        let data = new FormData()
        data.append('workflowExecutionId', this.id)
        data.append('workflowExecutionMemberId', this.idAuthorMessage)
        data.append('message', messagesChat.text)

        if (fileContent) {
            data.append('documento', fileContent)
        }

        data.append('timezone', this.timezone)

        if (messagesChat.usersMentioned && messagesChat.usersMentioned.length > 0) {
            data.append('usersMentioned', JSON.stringify(messagesChat.usersMentioned))
        }

        await this.workflowMessagesService.createWorkflowExecutionNewMessage(
            data,
            this.token
        )
    }

    markChatAsRead = async () => {
        try {
            await this.digitalVaultDocumentService.readDocumentMessage(this.id, this.token)
        } catch (e) { }
    }

    getMonetaryUnits = async () => {
        if (this.state.isExternalUserView) {
            return
        }
        if (this.loadingMonetaryUnits) {
            console.warn('getMonetaryUnits already in progress, skipping duplicate call')
            return
        }
        this.loadingMonetaryUnits = true
        let messageError = 'Ocurrio un error para consultar las unidades monetarias'
        try {
            let monetaryUnits = await this.questionnaireService.getAllCurrencyUnits(this.token)
            if (monetaryUnits.data.statusCode === 200 && monetaryUnits.data.data) {
                this.setState({
                    monetaryUnits: monetaryUnits.data.data,
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        } finally {
            this.loadingMonetaryUnits = false
        }
    }

    // Nuevo: flujo de eliminar/restaurar desde Inbox
    handleStartDeleteWorkflow = async (deleteDocument) => {
        const defaultMsg = 'Ocurrió un error al procesar la acción'
        try {
            this.toggleLoadingRequesting(true)
            const res = await this.digitalVaultService.startDeleteWorkflow(this.id, deleteDocument, this.token)
            if (res && (res.statusCode === 200 || res.statusCode === 201)) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
            } else {
                throw new Error(res?.message || defaultMsg)
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(e.message || defaultMsg, 4000, false)
        }
    }

    getDocumentAlerts = async () => {
        if (this.state.isExternalUserView) {
            return
        }
        const documentId = this.state.documentData?.id || this.id
        if (!documentId) {
            console.warn('No document ID available for getDocumentAlerts')
            return
        }
        let messageError = 'Ocurrió un error al consultar las alertas del documento'
        try {
            let documentAlerts = await this.alertService.getAllAlertConfigs(this.token, documentId)
            if (documentAlerts.statusCode === 200 && documentAlerts.data) {
                documentAlerts.data.alerts.forEach(alert => {
                    alert.alertDocumentVariables.forEach(alertVariable => {
                        alertVariable.name = alertVariable?.documentVariable?.variable?.variableName

                    })
                    return alert
                })
                this.setState({
                    documentAlerts: documentAlerts.data.alerts
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    getTypesDocumentsVariables = async () => {
        if (this.state.isExternalUserView) {
            return
        }
        const documentId = this.state.documentData?.id || this.id
        if (!documentId) {
            console.warn('No document ID available for getTypesDocumentsVariables')
            return
        }
        let messageError = this.props.t('digitalVaultDocumentView.getDocumentTypes.error')
        try {
            let typesDocuments = await DocumentsType.getTypesByDocumentId(documentId, this.token)
            if (typesDocuments.statusCode === 200 && typesDocuments.data) {
                let copyTypes = [{ id: 0, name: "Selecciona un dato" }, ...typesDocuments.data.variables]
                this.setState({
                    typesDocuments: copyTypes,
                    documentData: {
                        ...this.state.documentData,
                        typeDocumentId: this.state.documentData?.typeDocumentId || (Number.isFinite(Number(typesDocuments.data.id)) ? Number(typesDocuments.data.id) : typesDocuments.data.id)
                    }
                })
            } else if (typesDocuments.statusCode === 200 && !typesDocuments.data) {
                this.toggleLoadingView(false)
                this.toggleWarning(this.props.t('digitalVaultDocumentView.getDocumentTypes.warning'), 4000, this.props.t('digitalVaultDocumentView.getDocumentTypes.warning.title'))
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    /**
     * @type {CreateAlert}
     * @memberof DigitalVaultDocumentAction
     */
    createAlert = async (data) => {
        let result = false
        try {
            this.toggleLoadingRequesting(true)
            const alert = await this.alertService.createAlert(this.token, data)

            if (alert.statusCode === 200) {
                await this.getDocumentAlerts()
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
                result = true
                return result
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting('Ocurrió un error al crear la alerta', 4000, false, '/')
                result = false
                return result
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting('Ocurrió un error al crear la alerta', 4000, false, '/')
            result = false
            return result
        }
    }

    deleteAlert = async (alertId) => {
        let wasSuccessful = false
        try {
            this.toggleLoadingRequesting(true)
            const result = await this.alertService.deleteAlert(this.token, alertId)

            if (result.statusCode === 200) {
                await this.getDocumentAlerts()
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
                wasSuccessful = true
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('documentPanelBarAlerts.alerts.deleteError'), 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(this.props.t('documentPanelBarAlerts.alerts.deleteError'), 4000, false, '/')
        } finally {
            return wasSuccessful
        }
    }

    getFormatVariables = async () => {
        if (this.state.isExternalUserView) {
            return
        }
        if (this.loadingFormatVariables) {
            console.warn('getFormatVariables already in progress, skipping duplicate call')
            return
        }
        this.loadingFormatVariables = true
        try {
            let formatVariables = await this.questionnaireService.getAllFormatsForVariables(this.token)
            if (formatVariables.length) {
                formatVariables = formatVariables
                    .filter(f => f.groupName !== 'selection')
                    .map(f => ({
                        ...f,
                        format: this.props.t(`formatVariable.key.${f.key}`)
                    }))
                this.setState({
                    formatVariables
                })
            }
        } catch (e) {
            console.error('Error fetching format variables:', e)
        } finally {
            this.loadingFormatVariables = false
        }
    }

    /**
     * @param {*} data
     * @memberof DigitalVaultDocumentAction
     */
    createOrUpdateVariable = async (data) => {
        this.toggleLoadingRequesting(true)
        let messageError = this.props.t('digitalVaultDocumentView.createVariable.error')
        try {
            const payload = {
                variableId: (data?.variableId != null ? data.variableId : (data?.id != null ? data.id : null)),
                typeDocumentId: data.typeDocumentId,
                variableName: data.variableName || data.name,
                typeData: data.typeData || data.type,
                formatVariableKey: data.formatVariableKey || data.format,
                dataProfile: data.dataProfile || data.profile,
                mandatory: !!(data.mandatory),
                documentId: data.documentId || this.state.documentData.id,
                valueVariable: data.valueVariable ?? data.value ?? null,
                entityType: data.entityType ?? null,
                token: this.token
            }

            let resolvedTypeDocumentId = Number.isFinite(Number(payload.typeDocumentId)) && Number(payload.typeDocumentId) > 0
                ? Number(payload.typeDocumentId)
                : (Number.isFinite(Number(this.state.documentData?.typeDocumentId)) && Number(this.state.documentData?.typeDocumentId) > 0
                    ? Number(this.state.documentData?.typeDocumentId)
                    : null)

            if (!resolvedTypeDocumentId) {
                try {
                    const typesResp = await DocumentsType.getTypesByDocumentId(this.state.documentData.id, this.token)
                    const maybeId = Number(typesResp?.data?.id)
                    if (Number.isFinite(maybeId) && maybeId > 0) {
                        resolvedTypeDocumentId = maybeId
                        this.setState(prev => ({
                            documentData: { ...prev.documentData, typeDocumentId: maybeId }
                        }))
                    }
                } catch (_) { /* noop */ }
            }

            if (!resolvedTypeDocumentId) {
                this.toggleErrorRequesting('No se pudo determinar el tipo de documento (typeDocumentId).', 4000, false, '/')
                return
            }

            const resolvedDocumentId = payload.documentId ?? this.state.documentData?.id

            let response = await this.documentTypesService.createOrUpdateVariable({
                ...payload,
                typeDocumentId: resolvedTypeDocumentId,
                documentId: resolvedDocumentId
            })

            if (response.statusCode === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                        let docVars = documentInfo.data.document?.variables || []
                        docVars = docVars.map(variable => {
                            if (variable.value) variable.iconTrashActive = true
                            if (variable.typeData === 'boolean') {
                                variable.convertedValue = variable.value
                            } else {
                                variable.convertedValue = this.formatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                            }
                            return variable
                        })
                        this.setState({
                            documentData: {
                                ...documentInfo.data.document,
                                typeDocumentId: resolvedTypeDocumentId || this.state.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId
                            },
                            variables: docVars,
                            variablesGrid: response.data || []
                        })
                        await this.refreshDocumentVariables()
                        this.toggleLoadingRequesting(false)
                        this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'))
                        return true
                    } else {
                        const variables = response.data || []
                        this.setState({ variables, variablesGrid: variables })
                        this.toggleLoadingRequesting(false)
                        this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'))
                        return true
                    }
                } catch (e) {
                    const variables = response.data || []
                    this.setState({ variables, variablesGrid: variables })
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'))
                    return true
                }
            } else {
                switch (response.statusCode) {
                    case 409:
                        messageError = this.props.t('digitalVaultDocumentView.createVariable.error.nameAlreadyExists')
                        break
                    default:
                        messageError = this.props.t('digitalVaultDocumentView.createVariable.error')
                        break
                }
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
                return false
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return false
        }
    }

    /**
     * @param {import('../../../types/DocumentVariable.types').DocumentVariablePOSTData} data
     * @returns {Promise<boolean>}
     */
    createVariable = async (data) => {
        return this.createOrUpdateVariable(data)
    }

    /**
     * @param {import('../../../types/DocumentVariable.types').DocumentVariablePOSTData} data
     * @memberof DigitalVaultDocumentAction
     */
    updateVariable = async (data) => {
        let messageError = 'Ocurrió un error al actualizar la variable'
        try {
            this.toggleLoadingRequesting(true)
            let resolvedTypeDocumentId = Number.isFinite(Number(this.state.documentData?.typeDocumentId)) && Number(this.state.documentData?.typeDocumentId) > 0
                ? Number(this.state.documentData?.typeDocumentId)
                : null
            if (!resolvedTypeDocumentId) {
                try {
                    const typesResp = await DocumentsType.getTypesByDocumentId(this.state.documentData.id, this.token)
                    const maybeId = Number(typesResp?.data?.id)
                    if (Number.isFinite(maybeId) && maybeId > 0) {
                        resolvedTypeDocumentId = maybeId
                        this.setState(prev => ({ documentData: { ...prev.documentData, typeDocumentId: maybeId } }))
                    }
                } catch (_) { /* noop */ }
            }

            if (!resolvedTypeDocumentId) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting('No se pudo determinar el tipo de documento (typeDocumentId).', 4000, false, '/')
                return
            }
            const wantsValueUpdate = Object.prototype.hasOwnProperty.call(data || {}, 'valueVariable')

            const payload = {
                variableId: (data?.variableId != null ? data.variableId : data?.id),
                typeDocumentId: resolvedTypeDocumentId,
                variableName: (typeof data?.variableName === 'string' ? data.variableName : data?.name),
                typeData: (typeof data?.typeData === 'string' ? data.typeData : data?.type),
                // If empty string is received, treat as null to avoid unintended format changes
                formatVariableKey: (data?.formatVariableKey === '' ? null : (typeof data?.formatVariableKey === 'string' ? data.formatVariableKey : data?.format ?? null)),
                dataProfile: (data?.dataProfile != null ? data.dataProfile : data?.profile ?? null),
                mandatory: !!data?.mandatory,
                documentId: wantsValueUpdate ? (data?.documentId != null ? data.documentId : this.state.documentData?.id ?? null) : null,
                valueVariable: (Object.prototype.hasOwnProperty.call(data || {}, 'valueVariable') ? data.valueVariable : undefined),
                entityType: (data?.entityType != null ? data.entityType : null),
                token: this.token
            }

            if (!payload.variableId) {
                const byName = (this.state.variables || []).find(v => v && v.name === payload.variableName)
                if (byName && byName.id) payload.variableId = byName.id
            }

            if (!payload.variableId) {
                try {
                    const docInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    if (docInfo && docInfo.data && Number(docInfo.statusCode) === 200) {
                        const vars = docInfo.data.document?.variables || []
                        const byName = vars.find(v => v && v.name === payload.variableName)
                        if (byName && byName.id) {
                            payload.variableId = byName.id
                            this.setState({ variables: vars })
                        }
                    }
                } catch (_) { /* noop */ }
            }

            // Prevent accidental create when updating without variableId
            if (!payload.variableId) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting('No se pudo identificar el dato personalizado a actualizar. Vuelve a seleccionar el elemento e inténtalo de nuevo.', 4000, false, '/')
                return
            }

            let response = await this.documentTypesService.createOrUpdateVariable(payload)
            if (response.statusCode === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                        let docVars = documentInfo.data.document?.variables || []
                        docVars = docVars.map(variable => {
                            if (variable.value) variable.iconTrashActive = true
                            variable.convertedValue = FormatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                            return variable
                        })
                        this.setState({
                            documentData: {
                                ...documentInfo.data.document,
                                typeDocumentId: resolvedTypeDocumentId || this.state.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId
                            },
                            variables: docVars,
                            variablesGrid: response.data || []
                        })
                        await this.refreshDocumentVariables()
                        this.toggleLoadingRequesting(false)
                        this.toggleCompletedRequesting(3000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'), this.props.t('digitalVaultDocumentAction.variable.update.success'))
                    }
                } catch (e) {
                    this.toggleLoadingRequesting(false)
                }
            } else {
                this.toggleLoadingRequesting(false)
                if (Number(response.statusCode) === 409) {
                    this.toggleErrorRequesting('Ya existe un dato personalizado con ese nombre en este tipo de documento. Edita solo el valor, no el nombre.', 4500, false, '/')
                } else if (Number(response.statusCode) === 405) {
                    this.toggleErrorRequesting('El dato personalizado no fue encontrado.', 4000, false, '/')
                } else {
                    this.toggleErrorRequesting(messageError, 4000, false, '/')
                }
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    deleteVariable = async (variable) => {
        const messageError = 'Ocurrió un error al eliminar la variable'
        try {
            const variableId = (variable && typeof variable === 'object') ? Number(variable.id ?? variable.variableId) : Number(variable)
            if (!variableId) {
                this.toggleErrorRequesting('No se pudo determinar el id de la variable a eliminar.', 4000, false, '/')
                return false
            }
            const response = await this.documentTypesService.deleteVariable({ variableId, token: this.token })
            if (response.statusCode === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    const docVars = documentInfo?.data?.document?.variables || []
                    docVars.forEach(variable => {
                        if (variable.value) variable.iconTrashActive = true
                    })

                    this.setState(prev => ({
                        documentData: { ...documentInfo.data.document, typeDocumentId: prev.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId },
                        variables: docVars
                    }))
                    await this.refreshDocumentVariables()
                } catch (_) {
                    this.setState({ variables: response.data || [] })
                }
                this.toggleCompletedRequesting(3000, false, '/')
                return true
            } else if (Number(response.statusCode) === 410) {
                this.toggleErrorRequesting('El dato personalizado tiene valores asignados y no puede eliminarse.', 4000, false, '/')
                return false
            } else {
                this.toggleErrorRequesting(messageError, 4000, false, '/')
                return false
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return false
        }
    }

    /**
     * Borra solo el valor de una variable para el documento actual (no elimina la definición)
     * @param {import('../../../types/DocumentVariable.types').DocumentVariableGETResponse | { id: number } | number} variable
     * @returns {Promise<boolean>}
     */
    clearVariableValue = async (variable) => {
        const messageError = this.props.t('digitalVaultDocumentAction.variable.delete.error')
        const documentId = this.state?.documentData?.id
        try {
            this.toggleLoadingRequesting(true)
            const variableId = (variable && typeof variable === 'object') ? Number(variable.id ?? variable.variableId) : Number(variable)
            if (!variableId || !documentId) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.id'), 4000, false, '/')
                return false
            }

            const response = await this.documentTypesService.deleteVariableValue({ variableId, documentId, token: this.token })
            if (Number(response?.statusCode) === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    const docVars = documentInfo?.data?.document?.variables || []
                    docVars.forEach(variable => {
                        if (!variable.value) return variable
                        variable.iconTrashActive = true
                        if (variable.typeData === 'boolean') {
                            variable.convertedValue = variable.value
                        } else {
                            variable.convertedValue = this.formatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                        }
                        return variable
                    })
                    this.setState(prev => ({
                        documentData: { ...documentInfo.data.document, typeDocumentId: prev.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId },
                        variables: docVars
                    }))
                } catch (_) {
                    // Best-effort: fallback to mapping current variables with cleared value
                    const current = (this.state.variables || []).map(v => (v.id === variableId ? { ...v, value: null } : v))
                    this.setState({ variables: current })
                }
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'), this.props.t('digitalVaultDocumentAction.variable.delete.success'))
                return true
            } else if (Number(response?.statusCode) === 405) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.notValue'), 4000, false, '/')
                return false
            } else if (Number(response?.statusCode) === 404) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.userNotFound'), 4000, false, '/')
                return false
            } else if (Number(response?.statusCode) === 420) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.invalidData'), 4000, false, '/')
                return false
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
                return false
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return false
        }
    }

    handleAlerts = async (e, documentId) => {
        let newParams = new URLSearchParams()
        newParams.append('doc', documentId)
        this.props.history.push({ pathname: `/digital-vault/alerts`, search: newParams.toString() })
    }

    handleEditDoc = async () => {
        this.setState({
            showPrincipalView: false,
            showEditView: true
        })

        this.props.history.push({
            pathname: `/follow-up-registration-document/${this.state.documentData.id}`, state: {
                from: this.props.location.pathname,
                documentId: this.props.id,
                ...this.props.stateToMaintain
            }
        })
    }

    handlePrintDoc = async (e, documento, isDocument) => {
        let messageError = this.props.t('digitalVaultDocumentAction.errors.print')

        try {
            this.toggleLoadingRequesting(true)

            // Get the document URL
            let url = documento?.url || this.state.url

            // If it's an expediente and there's a selected file, use its URL
            if (isDocument && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
                const fileSelected = this.state.filesExpediente.find(file => file.selected)
                if (fileSelected?.url) {
                    url = fileSelected.url
                }
            }

            if (!url) throw new Error(this.props.t('digitalVaultDocumentAction.errors.print.no.url'))

            // Create the log
            let documentId = this.id
            let documentActionId = 6
            let sending = null
            let sharing = null
            await this.digitalVaultService.createDocumentLog(documentId, documentActionId, sending, sharing, this.token)

            // Decrypt the AWS URL
            const urlDecrypted = decryptMessageBoveda(url)

            // Create a temporary link and open in new window for printing
            const printWindow = window.open(urlDecrypted, '_blank')

            if (printWindow) {
                // Wait for it to load and then print
                printWindow.onload = () => {
                    printWindow.print()
                }
            } else {
                throw new Error(this.props.t('digitalVaultDocumentAction.errors.print.blocked.window'))
            }

            this.toggleLoadingRequesting(false)

        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            console.error('Error in handlePrintDoc:', error)
        }
    }

    handleDownloadDoc = async (isDocument) => {
        let messageError = this.props.t('digitalVaultDocumentView.download.error.message')
        let documentId = this.id
        if (isDocument && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
            const fileSelected = this.state.filesExpediente.find(file => { return file.selected })
            if (fileSelected && fileSelected.documentId) documentId = fileSelected.documentId
        }
        this.toggleLoadingRequesting(true)
        try {
            const response = await this.digitalVaultDocumentService.downloadFile({ documentId: documentId, token: this.token })
            if (response.statusCode === 200 && response.data) {
                if (!response.data.sendEmail && response.data.url) {
                    this.toggleLoadingRequesting(false)

                    const link = document.createElement('a')
                    link.href = response.data.url
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                    this.toggleCompletedRequesting(4000, false, '/', 'digitalVaultDocumentView.browserDownload.completed.title', 'digitalVaultDocumentView.browserDownload.completed.message')
                } else {
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(4000, false, '/', 'digitalVaultDocumentView.emailDownload.completed.title', 'digitalVaultDocumentView.emailDownload.completed.message')
                }
            }

        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/', 'digitalVaultDocumentView.download.error.title')
        }
    }


    handleSendEmailDoc = async (emails, documentId, comments, setEmail, setMessageEmail, fileIdExp) => {
        let messageError = 'Ocurrió un error al enviar el correo'
        try {
            let sendEmail = await this.categoryService.sendEmailDocumentVault(emails, documentId, comments, fileIdExp, this.token)
            if (sendEmail && Number(sendEmail.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                setEmail('')
                setMessageEmail('')
                this.toggleCompletedRequesting(3000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleShareDoc = async (payload, setUsersSend, setUsersSendGrid, setUsersChip, setShowDialogShare, setMessageShare) => {
        setShowDialogShare(false)
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al compartir el documento con los usuarios'

        try {
            const shareDocument = await this.categoryService.shareDocumentUsers(payload, this.token)
            if (shareDocument && Number(shareDocument.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                setUsersSend('')
                setUsersSendGrid([])
                setUsersChip([])
                setMessageShare('')
                this.toggleCompletedRequesting(3000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
            setShowDialogShare(true)
        }
    }

    handleDeleteDoc = async (documentToDelete) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un erro al eliminar el documento'

        try {
            let documentId = (documentToDelete && documentToDelete.id) ? documentToDelete.id : this.id
            let status = 'Papelera'
            let documentDeleted = await this.digitalVaultDocumentService.updateDocumentStatus(documentId, status, this.token)
            if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
                this.cache.deleteUrlFromCache('/documents-for-subcategory')
                if (documentToDelete && documentToDelete.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_DOC_DE_EXP) {
                    await this.getDocumentData()
                    return
                }

                if (this.props.goBack) this.props.goBack()

            } else if (documentDeleted && documentDeleted.data && (Number(documentDeleted.statusCode) === 5 || Number(documentDeleted.statusCode) === 8)) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 6) {
                messageError = 'No se actualizó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 7) {
                messageError = 'No se eliminó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleVersionDoc = async (e, setShowDialogVersion, documentId, fileIdExp) => {
        let messageError = 'Ocurrió un error al versionar el documento'
        setShowDialogVersion(false)
        this.toggleLoadingRequesting(true)
        let file = this.state.selectedFile
        let documentoToVersion = new FormData()
        documentoToVersion.append('documento', file)
        documentoToVersion.append('documentId', documentId)
        if (this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
            documentoToVersion.append('fileIdExp', fileIdExp)
        }

        try {
            let versionDocumento = await this.digitalVaultDocumentService.versionDocument(documentoToVersion, this.token)
            if (versionDocumento && versionDocumento.data && Number(versionDocumento.statusCode) === 200) {
                // this.handleFileWasUpload(file)
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.handleDeleteFile()
                this.getDocumentData()
            } else if (Number(versionDocumento.statusCode) === 4) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 5) {
                messageError = 'No se pudo guardar el documento en AWS'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 6) {
                messageError = 'Ocurrió un error al crear el registro en la base de datos'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleFile = async (e) => {
        this.setState({
            selectedFile: e.target.files[0],
            selectedFileName: e.target.files[0].name,
            errorFile: false,
            colorBorderContainer: 'green',
        })

        // Upload the base64 in the state
        let fileBase64 = await this.pdfToBase64(e.target.files[0])
        let pdfBase64 = fileBase64.split(',')[1]
        this.setState({ selectedFileBase64: pdfBase64 })
    }

    pdfToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
        })

    handleDeleteFile = (e) => {
        this.setState({
            selectedFile: null,
            errorFile: false,
            selectedFileBase64: '',
            colorBorderContainer: 'gray',
            fileWasUpload64: ''
        })
        return true
    }

    handleFileWasUpload = async (file) => {
        //Cambiar el documento que se mostraba de AWS por el que se acaba de seleccionar
        let fileBase64 = await this.pdfToBase64(file)
        let pdfBase64 = fileBase64.split(',')[1]
        this.setState({
            fileWasUpload64: pdfBase64
        })
    }

    handleShowPrincipalView = (e) => {
        this.setState({
            showEditView: false,
            showPrincipalView: true
        })
    }

    handleSelectVersion = (versionDoc) => {
        let url = (versionDoc && versionDoc.url && versionDoc.url !== '') ? decryptMessageBoveda(versionDoc.url) : ''
        if (url) {
            let copyVersions = this.state.versions
            let newVersions = copyVersions.map((version) => {
                if (versionDoc.id === version.id) {
                    version.selected = true
                } else {
                    version.selected = false
                }
                return version
            })
            const isMainVersion = versionDoc.statusType === this.ENV.REACT_APP_FILE_STATUS_MAIN_DOC ||
                versionDoc.statusType === this.ENV.REACT_APP_FILE_STATUS_MAIN_EXP
            this.setState({
                url,
                versions: newVersions,
                versionSelected: versionDoc,
                showPanelVaribales: isMainVersion,
                showPanelEntities: isMainVersion
            })
        }
    }

    handleDeleteFileVersion = async (fileId) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un erro al eliminar el documento'

        try {
            let documentId = this.id
            let status = 'Eliminar'
            let versionDeleted = await this.digitalVaultDocumentService.updateDocumentStatus(documentId, status, this.token, fileId)
            if (versionDeleted && versionDeleted.data && Number(versionDeleted.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (versionDeleted && (Number(versionDeleted.statusCode) === 5 || Number(versionDeleted.statusCode) === 8)) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 6) {
                messageError = 'No se actualizó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 7) {
                messageError = 'No se eliminó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 9) {
                messageError = 'No se eliminó el file en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 10) {
                messageError = 'No se puede eliminar el archivo principal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleMakeVersionMainDoc = async (version) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al hacer principal a la versión'
        let documentId = this.id
        let fileId = version.id
        let mainDoc = null
        if (this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
            mainDoc = version.mainDoc
        }
        try {
            let mainDocVersion = await this.digitalVaultDocumentService.makeVersionMainDoc(documentId, fileId, mainDoc, this.token)
            if (mainDocVersion && mainDocVersion.data && Number(mainDocVersion.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 4) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 5) {
                messageError = 'No se pudieron acutalizar las versiones a verDoc'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 6) {
                messageError = 'No se pudo actualizar la versión como principal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleWatchExp = (fileExp) => {
        if (!fileExp) return
        const newDocumentId = (fileExp.document && fileExp.document.id) ? fileExp.document.id : null
        this.openNewDocumentInView(null, newDocumentId)
    }


    handleSelectFileExp = (fileExp) => {
        if (!fileExp) return

        const isExternalDocument = fileExp.document && fileExp.document.url

        // Función auxiliar para detectar el tipo de archivo desde mimeType
        const detectFileTypeFromMimeType = (mimeType) => {
            if (!mimeType) return null

            const mime = mimeType.toLowerCase()

            // Imágenes
            if (mime.startsWith('image/')) {
                return 'image'
            }
            // Videos
            if (mime.startsWith('video/')) {
                return 'video'
            }
            // Audio
            if (mime.startsWith('audio/')) {
                return 'audio'
            }
            // PDF
            if (mime === 'application/pdf') {
                return 'pdf'
            }

            return null
        }

        // Función auxiliar para detectar el tipo de archivo desde la extensión
        const detectFileTypeFromExtension = (filename, rawExtension) => {
            const ext = rawExtension
                ? rawExtension.toLowerCase()
                : (filename ? filename.toLowerCase().split('.').pop() : '')

            if (ext === this.ENV.REACT_APP_ASN1_EXTENSION) {
                return this.ENV.REACT_APP_OCTET_STREAM_TYPE
            }
            // Imágenes
            if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) {
                return 'image'
            }
            // Videos
            if (['mp4', 'webm', 'ogg', 'mov', 'avi'].includes(ext)) {
                return 'video'
            }
            // Audio
            if (['mp3', 'wav', 'ogg', 'aac', 'm4a'].includes(ext)) {
                return 'audio'
            }
            // PDF
            if (ext === 'pdf') {
                return 'pdf'
            }
            // Por defecto
            return 'pdf'
        }

        // Determinar el tipo de archivo (PRIORIDAD: mimeType > fileType > extensión)
        let fileTypeToSet = 'pdf' // Por defecto PDF

        // 1. Primero intentar con mimeType (más confiable)
        if (fileExp.extension === this.ENV.REACT_APP_ASN1_EXTENSION) {
            fileTypeToSet = this.ENV.REACT_APP_OCTET_STREAM_TYPE
        } else if (fileExp.mimeType) {
            const typeFromMime = detectFileTypeFromMimeType(fileExp.mimeType)
            if (typeFromMime) {
                fileTypeToSet = typeFromMime
            } else {
                fileTypeToSet = detectFileTypeFromExtension(fileExp.fileName || fileExp.name, fileExp.extension)
            }
        } else {
            fileTypeToSet = detectFileTypeFromExtension(fileExp.fileName || fileExp.name, fileExp.extension)
        }

        let decryptUrl = ''

        if (isExternalDocument) {
            if (!fileExp.document || !fileExp.document.url) {
                console.error('[handleSelectFileExp] Error: El documento no tiene URL válida', fileExp)
                this.toggleErrorRequesting('El documento seleccionado no tiene una URL válida.', 3000)
                return
            }
            const rawUrl = fileExp.document.url

            try {
                decryptUrl = decryptMessageBoveda(rawUrl)
            } catch (e) {
                this.toggleErrorRequesting('Error al cargar el documento. Por favor intente nuevamente.', 3000)
                return
            }
        } else {
            decryptUrl = (fileExp && fileExp.url && fileExp.url !== '') ? decryptMessageBoveda(fileExp.url) : ''
        }

        const isAsn1OctetFile = (expediente, ENV) => {
            return (
                expediente.fileType === ENV.REACT_APP_OCTET_STREAM_TYPE &&
                expediente.extension === ENV.REACT_APP_ASN1_EXTENSION
            )
        }

        const asn1Decode = isAsn1OctetFile(fileExp, this.ENV)
            ? [fileExp.asn1Parse]
            : []

        if (isExternalDocument) {
            let copyExternalDocs = [...this.state.externalDocuments]
            let newExternalDocs = copyExternalDocs.map((file) => {
                if (file.id === fileExp.id) {
                    file.selected = true
                } else {
                    file.selected = false
                }
                return file
            })

            this.setState({
                url: decryptUrl,
                asn1Decode,
                showVersions: false,
                versions: [],
                externalDocuments: newExternalDocs,
                fileExpSelected: fileExp,
                versionSelected: null,
                showPanelVaribales: false,
                showPanelEntities: false,
                showPDF: true,
                fileType: fileTypeToSet
            }, () => {
                this.forceUpdate()
            })
        } else {
            let copyFilesExp = this.state.filesExpediente
            let newFilesExp = copyFilesExp.map((file) => {
                if (file.id === fileExp.id) {
                    file.selected = true
                } else {
                    file.selected = false
                }
                return file
            })

            let showVersions = (fileExp.versions && fileExp.versions.length > 0) ? true : false

            const isMainFile = fileExp.statusType === this.ENV.REACT_APP_FILE_STATUS_MAIN_EXP ||
                fileExp.statusType === this.ENV.REACT_APP_FILE_STATUS_MAIN_DOC

            this.setState({
                url: decryptUrl,
                asn1Decode,
                showVersions,
                versions: fileExp.versions,
                filesExpediente: newFilesExp,
                fileExpSelected: fileExp,
                versionSelected: fileExp,
                showPanelVaribales: isMainFile,
                showPanelEntities: isMainFile,
                showPDF: true,
                fileType: fileTypeToSet
            })
        }

    }

    addNewFileToExp = async (e) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al guardar el documento'
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            messageError = 'Selecciona un archivo'
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
            return
        }

        let file = e.target.files[0]
        let documentId = this.state.documentData.id
        let documentData = new FormData()
        documentData.append('newDocument', file)
        documentData.append('documentId', documentId)

        try {
            let addFile = await this.digitalVaultDocumentService.addFileToExpediente(documentData, this.token)
            if (addFile && addFile.data && Number(addFile.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (Number(addFile.statusCode) === 403) {
                messageError = 'El usuario no existe en el sistema'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(addFile.statusCode) === -4) {
                messageError = 'El expediente no exxiste en el sistema'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(addFile.statusCode) === -5 || Number(addFile.statusCode) === -6) {
                messageError = 'Ocurrió un error al guardar el documento'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleSignRequest = () => {
        this.props.history.push({
            pathname: `/signature-request-profile/1`,
            params: {
                documentData: this.state.documentData,
            },
        })
    }

    setShowDialogEntities = () => {
        const documents = []
        const typeFile = (this.state.documentData && this.state.documentData.infoType && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) ? this.ENV.REACT_APP_FILE_STATUS_MAIN_EXP : this.ENV.REACT_APP_FILE_STATUS_MAIN_DOC
        const mainDocs = this.state.filesDocument.filter(doc => doc.statusType === typeFile && doc.fileType === 'pdf')
        mainDocs.forEach((doc) => {
            documents.push({
                id: doc.id,
                name: doc.fileName,
                pages: doc.pages
            })
        })

        if (documents.length === 0) {
            this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.errors.no.docs.entities'), 4000, false)
            return
        }

        const docsCreditsOCR = setCreditsToDocuments(documents, this.props.t)
        const documentsToOCR = (docsCreditsOCR && docsCreditsOCR.documentsToOCR) ? docsCreditsOCR.documentsToOCR : []
        const totalCredits = (docsCreditsOCR && docsCreditsOCR.totalCredits) ? docsCreditsOCR.totalCredits : 0

        this.setState({
            showDialogExtractEntities: true,
            documentsToOCR,
            totalCredits
        })
    }

    setCloseDialogEntities = () => {
        this.setState({
            showDialogExtractEntities: false,
            documentsToOCR: [],
            totalCredits: 0
        })
    }

    handleInfoClose = () => {
        this.setState({
            showInfoRequesting: false,
            labelInfoBtn: '',
            infoMessage: ''
        })
    }

    handleNoAccessClose = () => {
        this.setState({ showNoAccessModal: false })
        this.props.history.replace('/')
    }

    handleNotYetAnalyze = () => {
        this.setState({
            infoTitle: this.props.t('documentPanelBarEntities.analyzeAI.title'),
            showInfoRequesting: true,
            labelInfoBtn: this.props.t('button.understood'),
            infoMessage: this.props.t('documentPanelBarEntities.analyzeAI.message')
        })
    }

    saveExtractedEntities = async () => {
        let messageError = this.props.t('digitalVaultDocumentAction.errors.save.entities')
        try {
            let documentsSendToOCR = this.state.documentsToOCR.filter(doc => doc.value)
            documentsSendToOCR = documentsSendToOCR.map((doc) => {
                doc.fileId = doc.id
                return doc
            })

            if (documentsSendToOCR.length === 0) {
                messageError = this.props.t('digitalVaultDocumentAction.errors.no.docs.entities')
                this.setCloseDialogEntities()
                this.toggleErrorRequesting(messageError, 4000, false)
                return
            }

            if (this.state.preferenceIA === this.ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_AUTOMATIC || this.state.preferenceIA === this.ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_BOTH) {
                const documents = []
                const typeFile = (this.state.documentData && this.state.documentData.infoType && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) ? this.ENV.REACT_APP_FILE_STATUS_MAIN_EXP : this.ENV.REACT_APP_FILE_STATUS_MAIN_DOC
                const mainDocs = this.state.filesDocument.filter(doc => doc.statusType === typeFile && doc.fileType === 'pdf')
                mainDocs.forEach((doc) => {
                    documents.push({
                        id: doc.id,
                        name: doc.fileName,
                        pages: doc.pages
                    })
                })

                const docsCreditsOCR = setCreditsToDocuments(documents, this.props.t)
                documentsSendToOCR = (docsCreditsOCR && docsCreditsOCR.documentsToOCR) ? docsCreditsOCR.documentsToOCR : []
            }

            this.setCloseDialogEntities()
            this.toggleLoadingRequesting(true)

            const extractEntities = await this.digitalVaultDocumentService.sendEntitiesToExtract(this.id, documentsSendToOCR, this.token)
            if (extractEntities && extractEntities.data && Number(extractEntities.statusCode) === 200) {
                this.setState({
                    entitiesStatus: this.ENV.REACT_APP_EVENT_TRANSACTION_STATUS_OCR_PROCESSING,
                    showBtnExtractEntities: false
                })
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }

    }

    handleCheckBoxDoc = async (e, dataItem) => {
        let copyDocs = [...this.state.documentsToOCR]
        let valueCheck = e.target.checked

        // Restriction: Do not allow deselecting processId 3 if processId 4 or 6 is selected for the same file.
        if (dataItem.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_OCR_ID) && !valueCheck) {
            const hasProcess4Or6Selected = copyDocs.some(doc =>
                doc.id === dataItem.id &&
                (doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_ENTITIES_EXTRACTION_ID) || doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_EMBEDDINGS_ID)) &&
                doc.value
            )

            // if processId 4 or 6 is selected, prevent deselecting processId 3
            if (hasProcess4Or6Selected) {
                return
            }
        }

        // Toggle the value property of the target document
        copyDocs = copyDocs.map((doc) => {
            if (doc.id === dataItem.id && doc.processId === dataItem.processId) {
                doc.value = valueCheck
            }
            return doc
        })

        // Auto-selection logic: If the current document is processId 4 or 6, manage processId 3 of the same file
        if (dataItem.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_ENTITIES_EXTRACTION_ID) || dataItem.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_EMBEDDINGS_ID)) {
            // Find processId 3 of the same file (same id, different processId)
            const process3SameFile = copyDocs.find(doc => doc.id === dataItem.id && doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_OCR_ID))

            if (process3SameFile) {
                if (valueCheck) {
                    // If processId 4 or 6 is being selected, auto-select processId 3 of the same file
                    process3SameFile.value = true
                } else {
                    // If processId 4 or 6 is being deselected, check if there are other 4 or 6 selected for the same file
                    const hasOtherProcess4Or6Selected = copyDocs.some(doc =>
                        doc.id === dataItem.id &&
                        (doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_ENTITIES_EXTRACTION_ID) || doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_EMBEDDINGS_ID)) &&
                        doc.processId !== dataItem.processId &&
                        doc.value
                    )

                    // If no other processId 4 or 6 is selected for this file, deselect processId 3
                    if (!hasOtherProcess4Or6Selected) {
                        process3SameFile.value = false
                    }
                }
            }
        }

        // Recalculate total credits
        let totalCredits = 0
        copyDocs.forEach(doc => {
            if (doc.value) {
                totalCredits += doc.credits || 0
            }
        })

        this.setState({
            documentsToOCR: copyDocs,
            totalCredits
        })
    }

    openNewDocumentInView = (e, newDocumentId) => {
        if (e) e.preventDefault()
        if (!newDocumentId) return
        const messageError = 'Ocurrió un error al consultar el documento'

        this.toggleLoadingView(true)
        this.id = newDocumentId
        try {
            this.getDocumentData()
            this.getBinnacle()
            this.getUsersCollabs()
            this.getMonetaryUnits()
            this.getFormatVariables()
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    refreshDocumentVariables = async () => {
        try {
            await this.getTypesDocumentsVariables()
            await this.getDocumentAlerts()
        } catch (e) {
            console.log(e)
        }
    }

    getDocumentTypes = async () => {
        if (this.state.isExternalUserView) {
            return
        }
        try {
            const documentTypes = await this.documentTypesService.getAllTypeDocuments(this.token)
            if (!documentTypes || !documentTypes.data) throw new Error('No document types found')
            const filteredDocumentTypes = documentTypes.data.filter(docType => docType.infoType === this.state.documentData.infoType)
            this.setState({ documentTypes: filteredDocumentTypes || [] })
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting('', 4000, false)
        }
    }

    // Get client preferences
    getClientPreferences = async () => {
        if (this.state.isExternalUserView) {
            return
        }
        try {
            const clientPreferences = await this.clientPreferencesService.getClientPreferences(this.token, this.timezone)
            let preferenceIAFound = clientPreferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_DOCUMENT_TO_OCR)
            const preferenceIA = (preferenceIAFound && preferenceIAFound.stringValue) ? preferenceIAFound.stringValue : process.env.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ON_DEMAND
            this.setState({
                preferenceIA
            })
            return preferenceIA
        } catch (error) {
            return process.env.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ON_DEMAND
        }

    }

    /**
     * @function fetchDocumentGroupsAndTemplates
     * @description Obtiene los grupos y templates de documentos para configurar listas
     * @returns {Promise<void>}
     * @memberof DigitalVaultDocumentAction
     */
    fetchDocumentGroupsAndTemplates = async () => {
        try {
            const data = await this.categoryService.getDocumentGroupsAndTemplates(this.token)
            this.setState({
                documentGroups: data.groups || [],
                documentTemplates: data.documents || []
            })
        } catch (error) {
            console.error('Error al obtener grupos y templates de documentos:', error)
            this.setState({
                documentGroups: [],
                documentTemplates: []
            })
        }
    }

    /**
     * @function setSelectedUsers
     * @description Actualiza la lista de usuarios seleccionados para solicitud de documentos
     * @param {Array|Function} users - Array de usuarios o función que recibe estado previo
     * @returns {void}
     */
    setSelectedUsers = (users) => {
        if (typeof users === 'function') {
            this.setState(prevState => ({ selectedUsers: users(prevState.selectedUsers) }))
        } else {
            this.setState({ selectedUsers: users })
        }
    }

    /**
     * @function setUserDocumentLists
     * @description Actualiza las listas de documentos por usuario
     * @param {Object|Function} lists - Objeto con listas de documentos por email o función
     * @returns {void}
     */
    setUserDocumentLists = (lists) => {
        if (typeof lists === 'function') {
            this.setState(prevState => ({ userDocumentLists: lists(prevState.userDocumentLists) }))
        } else {
            this.setState({ userDocumentLists: lists })
        }
    }

    /**
     * @function setUserInstructions
     * @description Actualiza las instrucciones por usuario
     * @param {Object|Function} instructions - Objeto con instrucciones por email o función
     * @returns {void}
     */
    setUserInstructions = (instructions) => {
        if (typeof instructions === 'function') {
            this.setState(prevState => ({ userInstructions: instructions(prevState.userInstructions) }))
        } else {
            this.setState({ userInstructions: instructions })
        }
    }

    /**
     * @function setRequestDeadline
     * @description Actualiza la fecha límite de solicitud
     * @param {Date} deadline - Fecha límite
     * @returns {void}
     */
    setRequestDeadline = (deadline) => {
        this.setState({ requestDeadline: deadline })
    }

    /**
     * @function setEnableSecondApproval
     * @description Activa/desactiva la segunda aprobación
     * @param {boolean} enabled - Si está habilitada la segunda aprobación
     * @returns {void}
     */
    setEnableSecondApproval = (enabled) => {
        this.setState({ enableSecondApproval: enabled })
    }

    /**
     * @function setSecondApprovalUser
     * @description Establece el usuario para segunda aprobación
     * @param {Object|null} user - Usuario para segunda aprobación
     * @returns {void}
     */
    setSecondApprovalUser = (user) => {
        this.setState({ secondApprovalUser: user })
    }

    /**
     * @function onSaveDocumentList
     * @description Guarda la lista de documentos configurada para un usuario específico
     * @param {string} userEmail - Email del usuario
     * @param {Array} selectedDocumentIds - IDs de documentos seleccionados
     * @returns {void}
     */
    onSaveDocumentList = (userEmail, selectedDocumentIds) => {
        this.setState(prevState => ({
            userDocumentLists: {
                ...prevState.userDocumentLists,
                [userEmail]: selectedDocumentIds
            }
        }))
    }

    render() {
        return (
            <DigitalVaultDocumentView
                {...this.props}
                {...this.state}
                handleInfoClose={this.handleInfoClose}
                handleNoAccessClose={this.handleNoAccessClose}
                handleNotYetAnalyze={this.handleNotYetAnalyze}
                toggleWarning={this.toggleWarning}
                createOrUpdateVariable={this.createOrUpdateVariable}
                createAlert={this.createAlert}
                deleteAlert={this.deleteAlert}
                updateVariable={this.updateVariable}
                createVariable={this.createVariable}
                clearVariableValue={this.clearVariableValue}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleLoadingView={this.toggleLoadingView}
                handleAlerts={this.handleAlerts}
                handleEditDoc={this.handleEditDoc}
                handlePrintDoc={this.handlePrintDoc}
                handleDownloadDoc={this.handleDownloadDoc}
                handleSendEmailDoc={this.handleSendEmailDoc}
                handleShareDoc={this.handleShareDoc}
                handleDeleteDoc={this.handleDeleteDoc}
                handleVersionDoc={this.handleVersionDoc}
                handleSignRequest={this.handleSignRequest}
                handleFile={this.handleFile}
                handleDeleteFile={this.handleDeleteFile}
                handleShowPrincipalView={this.handleShowPrincipalView}
                handleSelectVersion={this.handleSelectVersion}
                handleDeleteFileVersion={this.handleDeleteFileVersion}
                handleMakeVersionMainDoc={this.handleMakeVersionMainDoc}
                handleWatchExp={this.handleWatchExp}
                handleSelectFileExp={this.handleSelectFileExp}
                addNewFileToExp={this.addNewFileToExp}
                setShowDialogEntities={this.setShowDialogEntities}
                setCloseDialogEntities={this.setCloseDialogEntities}
                saveExtractedEntities={this.saveExtractedEntities}
                handleCheckBoxDoc={this.handleCheckBoxDoc}
                handleStartDeleteWorkflow={this.handleStartDeleteWorkflow}
                handleDeletePermanently={this.handleDeletePermanently}
                handleRestoreDocument={this.handleRestoreDocument}
                deleteVariable={this.deleteVariable}
                openNewDocumentInView={this.openNewDocumentInView}
                handleInputChangeChat={this.handleInputChangeChat}
                createMessage={this.createMessage}
                markChatAsRead={this.markChatAsRead}
                handleUploadExternalDocument={this.handleUploadExternalDocument}
                handleDeleteExternalDocument={this.handleDeleteExternalDocument}
                handleExternalDocumentAction={this.handleExternalDocumentAction}
                handleCancelRequest={this.handleCancelRequest}
                handleCloseRequest={this.handleCloseRequest}
                handleSendThirdPartyRequest={this.handleSendThirdPartyRequest}
                externalDocumentsStatusCurrent={this.state.externalDocumentsStatusCurrent}
                documentOwnerId={this.state.documentOwnerId}
                externalDocumentsCurrentUserId={this.state.externalDocumentsCurrentUserId}
                selectedUsers={this.state.selectedUsers}
                setSelectedUsers={this.setSelectedUsers}
                userDocumentLists={this.state.userDocumentLists}
                setUserDocumentLists={this.setUserDocumentLists}
                userInstructions={this.state.userInstructions}
                setUserInstructions={this.setUserInstructions}
                requestDeadline={this.state.requestDeadline}
                setRequestDeadline={this.setRequestDeadline}
                enableSecondApproval={this.state.enableSecondApproval}
                setEnableSecondApproval={this.setEnableSecondApproval}
                secondApprovalUser={this.state.secondApprovalUser}
                setSecondApprovalUser={this.setSecondApprovalUser}
                documentGroups={this.state.documentGroups}
                documentTemplates={this.state.documentTemplates}
                onSaveDocumentList={this.onSaveDocumentList}

            />
        )
    }
}

export default withRouter(withTranslation()(DigitalVaultDocumentAction))